
import pic from '@/utils/pic'
const { icon1, icon2, icon3, langzh, langen, langtw, langjp, langar,langxby,langdy,langfy,langhy,langty,langyn,zhsz, jtrz, sfrz, iconchecked, iconcheck,icon1_01,icon1_02,icon1_03,icon1_04,banner01,banner02,banner03 } = pic

export default {
  "公告详情":"Announcement details",
  "未读":"Not yet read",
  "已读":"Read",
  "主动取消":"Cancel",
  "申请拒绝":"Application refused",
  "赎回拒绝":"Redemption refused",
  "重新申请":"Reapply",
  "撤回申请":"Withdrawal canceled",
  "在这里购买有潜力的":"Buy potential here",
    "什么是新币申购？":"What is new coin subscription?",
    "投资价值高":"High investment value",
    "新币价格低，潜在价值高，适合投资":"The new currency has low price and high potential value, suitable for investmen",
    "无手续费":"No handling fee",
    "购买新币不需要任何手续费":"No fees required for purchasing new coins",
    "是交易产品中风险最低且收益稳定的一种投资方式":"It is an investment method with the lowest risk and stable returns among trading products.",
    "产品":"product",
    "我的申购订单":"My Purchase Order",
    "总数量":"Total quantity",
    "已认购量":"Subscribed Amount",
    "剩余数量":"Remaining quantity",
    "锁仓天数":"Lock-up days",
    "浅色模式":"Light Mode",
    "深色模式":"Dark Mode",
  "修改昵称":"Change Nickname",
  "昵称":"Nickname",
  "头像":"Avatar",
  "绑定邮箱":"Bind Email",
  "绑定手机号":"Bind Phone",
  "未绑定":"Unbound",
  "上传头像":"Upload Avatar",
  "修改头像":"Change Avatar",
  "个人信息":"Personal Information",
  "我们发送了验证码至":"We sent the verification code to",
  "中":"in",
  "请输入获取到的验证码以激活账户":"Please enter the verification code to activate your account",
    "请输入昵称":"Please enter your nickname",
    "手机号":"Phone number",
    "邮箱号":"Email number",
    "请输入邮箱号":"Please enter your email number",
  "白皮书":"White paper",
  "驾驶证":"Driver's license",
  "居住证":"Residence card",
  "通过时间":"Processing time",
  "银行账户":"Bank Account",
    "请输入银行账户":"Please enter the bank account number.",
    "银行国际代码":"SWIFT Code",
    "请输入国际代码":"Please enter int'l code.",
    "电话号码":"Phone Number",
    "请输入电话号码":"Please enter your phone number",
    "上传房屋证明":"Upload Housing Proof",
    "上传收入证明":"Upload Income Proof",
    "上传银行证明":"Upload Bank Proof",
    "上传证件照":"Upload ID Photo",
    "提示:您可以通过上传证明来提高信用分":"Tip: You can improve your credit score by uploading proofs.",
    "谷歌验证码":"Google Code",
    "修改谷歌验证码":"Modify Google verification code",
    "扫描二维码绑定":"Scan QR code to bind",
    "输入验证码":"Enter verification code",
    "你知道吗？":"Did you know?",
    "绑定2FA认证,提款时需要取得您的认证,资金更安全":"Bind 2FA for safer withdrawals",
    "立即绑定":"Bind now",
    "请输入原绑定的谷歌验证码":"Enter original Google verification code",
    "重新绑定":"Rebinding",
    "交易密码":"Transaction Password",
    "请输入交易密码":"Please enter password",
    "请输入谷歌验证码":"Please enter Google code",
    "请到安全中心设置交易密码":"Set transaction password in security center",
    "请到安全中心设置谷歌验证":"Set Google verification in security center",
    "请输入验证码":"Please enter code",
    "信用分":"Credit score",
  "关闭":"Close",
  "查看详情":"View details",
  "向卖家付款":"Pay the seller",
    "获取您的币种":"Get your currency",
    "我的订单":"My orders",
    "未匹配":"Unmatched",
    "已匹配":"Matched",
    "已完成":"Finished",
    "已过期":"Expired",
    "已过期":"Expired",
      "合同号":"Contract No.",
      "买入金额":"Buy Amount",
      "邮箱":"Mail",
      "请输入您的电子邮箱":"Please enter your email address",
      "请选择购买的货币":"Please select the currency you want to purchase",
      "请选择支付的货币":"Please select the currency you want to pay",
      "请填写您的收款信息，如有需要补充信息请填写到备注栏或者联系客服。":"Por favor, rellene sus datos de pago. Si necesita información adicional, rellene la columna de observaciones o póngase en contacto con el servicio de atención al cliente.",
      "备注":"Remark",
      "请选择币种":"Please select a currency",
      "请输入钱包地址":"Please enter a wallet address",
      "绑定钱包":"Bind a wallet",
      "钱包地址":"Wallet Address",
      "请输入备注":"Please enter a note",
      "提现地址":"Withdrawal address",
      "添加钱包地址":"Add wallet address",
      "钱包管理":"Wallet Management",
      "请填写数量":"Fill in the quantity",
      "已锁仓":"Locked staking",
    "重要提示：":"Important tips:",
    "订单有效期：买方或卖方需在发起订单后3小时内完成交易。如未能完成，请及时联系在线客服确认订单状态。":"Order validity period: The buyer or seller must complete the transaction within 3 hours after initiating the order. If it fails to be completed, please contact the online customer service in time to confirm the order status.",
    "订单失效：若未在规定时间内联系客服，订单将自动失效，无法恢复。":"Order expiration: If you do not contact the customer service within the specified time, the order will automatically expire and cannot be restored.",
    "安全保障：我们提供全面的交易保障措施，确保您的资金和交易信息安全。":"Security guarantee: We provide comprehensive transaction protection measures to ensure the safety of your funds and transaction information.",

    "充值":"Deposit",
    "提现":"Withdraw",
    "兑换":"Convert",
    "今日收益":"P&L (Today)",
    "现金":"Ready",
    "交易":"trade",
    "理财":"Financial Management",
    "资产列表":"Asset List",
  "已锁仓":"Locked staking",
  "最高可贷款":"Maximum loanable amount",
  "请先完成高级认证":"Please complete advanced verification",
  "贷款金额":"Loan Amount",
  "总还款额":"Total repayment",
  "金融":"Finance",
  "选择周期":"Select cycle",
  "选择类型":"Select Type",
  "结算价":"Settlement Price",
  "限价卖出":"Sell Limit",
  "截止价卖出":"Sell Stop",
  "加密货币":"Crypto",
  "银行卡":"Bank Card",
  "金额":"Amount",
  "选择银行":"Select a bank",
  "提款需要的手续费,这需要由网络节点确认, 才能记入请不要将加密货币转让给陌生人":"The withdrawal fee needs to be confirmed by the network node before it can be credited. Please do not transfer cryptocurrency to strangers",
  "银行卡管理":"Bank card management",
  "绑定银行卡":"Bind bank card",
  "添加":"Add",
  "添加银行卡":"Add bank card",
  "修改银行卡":"Modify bank card",
  "请添加银行卡":"Please add a bank card",
  "数量":"Quantity",
  "继续下单":"Continue",
  "路由号码":"Routing number",
  "请输入路由号码":"Please enter a routing number",
  "搜索":"Search",

  "限价买入":"Limit Buy",
  "截止价买入":" Stop Price Buy",
  "限价卖出":"Sell Limit",
  "截止价卖出":"Sell Stop",
  "贷款金额":"Loan Amount",
  "总还款额":"Total repayment",
  "委托总量":"Total",
  "交易总额":"Total transaction amount",
  "成交价格":"Transaction price",
  "委托价格":"Commission Price",
  "顶尖交易技术":"Top trading technology",
  "通过我们的先进交易系统，您可以精准把握市场动态，高效执行每一笔交易！":"Through our advanced trading system, you can accurately grasp market trends and execute each transaction efficiently!",
  "累计收入":"Accumulated income",
    "每日收益":"Daily income",
    "助您探索更多交易机会和":"Help you explore more trading opportunities and",
    "金融产品":"Financial products",
    "什么是活期借贷？":"What is a current loan?",
    "累计利息":"Accumulated interest",
    "申请金额":"Application amount",
  "风险":"Risk",
  "审核结果":"Review Result",
  "您的等级为":"Your Level is",
  "未评估":"Not Assessed",
  "谨慎性":"Conservative",
  "稳健型":"Balanced",
  "进取型":"Aggressive",
  "提示：您的风险承受为谨慎型，最高投资额为":"Note: Your risk tolerance is Conservative, and the maximum investment amount is",
  "如果您想提高额度请重新评估或联系客服":"If you want to increase the limit, please reassess or contact customer service",
  "重新评估":"Reassess",
  "验证中,请耐心等待系统审核":"Under verification, please wait patiently for system review",
  "确保符合平台的合规要求并完成您的投资者资格认证,我们需要您提供以下信息,请放心,您提供的所有资料将储存在我们高度加密和安全的资料库中,完全符合国际安全标准。我们非常重视您的资讯隐私,未经您的明确同意,绝不外泄或者分享这些资料":"To ensure compliance with platform requirements and complete your investor qualification certification, we need you to provide the following information. Rest assured, all the information you provide will be stored in our highly encrypted and secure database, fully compliant with international security standards. We highly value your information privacy and will never disclose or share this information without your explicit consent.",
  "了解产品":"Learn About the Product",
  "C2C快捷买币只要三个":"C2C Quick Coin Purchase in Just Three",
  "步骤完成":"Steps Completed",
  "什么是C2C?":"What is C2C?",
  "请输入付款银行名称":"Please Enter the Payment Bank Name",
  "请选择币种":"Please Select Currency",
  "查看订单":"View Orders",
  "查看汇款账号":"View Remittance Account",
  "订单金额":"Order Amount",
  "卖家收款账号":"Seller's Payment Account",
  "账户名称":"Account Name",
  "账户号":"Account Number",
  "银行名称":"Bank Name",
  "银行地址":"Bank Address",
  "距离本次电汇订单有效期还剩":"Time Left for This Wire Transfer Order",
  "买入金额":"Purchase Amount",
  "查看汇款账号":"View Remittance Account",
  "请输入订单号":"Please Enter the Order Number",
  "职业":"Occupation",
  "请输入职业":"Please Enter Occupation",
  "财富来源":"Source of Wealth",
  "请输入财富来源":"Please Enter Source of Wealth",
  "预期投资金额":"Expected Investment Amount",
  "请输入预期投资金额":"Please Enter Expected Investment Amount",
  "资产证明":"Asset Proof",
  "请上传资产证明":"Please Upload Asset Proof",
  "借贷":"Lending",
  "我的贷款订单":"My Loan Orders",
  "借贷金额":"Loan Amount",
  "可借额度":"Available Loan Limit",
  "借贷天数":"Loan Days",
  "请选择天数":"Please Select Days",
  "立即借币":"Borrow Coins Now",
  "当前借贷":"Current Loan",
  "当前信用分":"Current Credit Score",
  "还款总额":"Total Repayment Amount",
  "还款日期":"Repayment Date",
  "产品亮点":"Product Highlights",
  "超低利息":"Ultra-low Interest",
  "为了回馈新老用户，平台借贷超低利息费用":"To reward new and existing users, the platform offers ultra-low loan interest rates",
  "当天下发":"Same-day Disbursement",
  "当天贷款，最快当天下发至您的账户里":"Loans processed on the same day can be disbursed to your account as quickly as the same day",
  "24小时在线客服":"24/7 Online Customer Service",
  "24小时在线客服，满足您的贷款需求":"24/7 online customer service to meet your loan needs",
  "产品规则":"Product Rules",
  "单位":"Unit",
  "获利":"Profit",
  "稳健型ETF订单":"Balanced ETF Orders",
  "低风险ETF订单":"Low-risk ETF Orders",
  "VIP理财订单":"VIP Wealth Management Orders",
  "输入地址":"Enter Address",
  "购买":"Purchase",
  "当前可用":"Currently Available",
  "请验证您的助记词以确认钱包所有权,然后提交您的加密地址":"Please verify your mnemonic to confirm wallet ownership, then submit your crypto address",
  "地址":"Address",
  "验证码助记词":"Mnemonic Verification Code",
  "产品亮点":"Product Highlights",
  "100%资金安全保障":"100% Fund Security Guarantee",
  "我们致力于确保金融产品和服务对投资者公平":"We are committed to ensuring financial products and services are fair to investors",
  "正规平台受政府监管":"Regulated Platform Under Government Supervision",
  "我们主动接受各级政府监管和合规经营":"We actively accept government supervision at all levels and operate in compliance",
  "当天起息":"Interest Accrued on the Same Day",
  "当天成功存入后，马上计算收益":"Interest starts accruing immediately after successful deposit on the same day",
  "加密钱包地址":"Crypto Wallet Address",
  "请输入助记词":"Please Enter Mnemonic",
  "助记词无效":"Invalid Mnemonic",
  "请输入钱包地址":"Please Enter Wallet Address",

  "存储人姓名":"Name of depositor",
  "付款银行名称":"Name of paying bank",
  "买卖币种":"Buy&sell currencies",
  "选择币种":"Select Currency",
  "付款方式":"Payment Methods",
  "法币":"Fiat Money",
  "电汇":"T/T",
  "输入法币":"Input Fiat Currency",
  "存款金额":"Deposit Amount",
  "请输入金额":"Please enter amount",
  "上传汇款凭证":"Upload Remittance Proof",
  "请输入订单号":"Please enter your order number",
  "低风险":"Low risk",
  "稳健型":"Robust",
  "基金":"Fund",
  "类型":"Type",
  "输入":"Enter",
  "立即参与":"Join Now",
  "什么是低风险ETF?":"What is low-risk ETFs?",
  "什么是稳健型ETF?":"What is a conservative ETF?",
  "什么是VIP理财？":"What is VIP Financial Management?",
  "买币流程":"Buy currency process",
  "创建预订单":"Create pre-order",
  "联系客服":"Customer service",
  "提交凭证":"Certificate",
  "创建订单":"Create Order",
  "我们的优势":"Our advantages",
  "低廉的交易费用":"Low Transaction Fee",
  "在我们的C2C买币上，下单方以零手续费交易，我承诺在所有市场用最低的C2C交易费用":"On our C2C buying currency, the ordering party trades with zero transaction fees. We promise to apply the lowest C2C transaction fees in all markets.",
  "多种支付方式":"Multiple payment methods",
  "点对点（C2C）交易允许卖家自由定义透明想要的付款方式，通过700多种支付方式买卖加密货币，包括银行转账、现金。":"Peer-to-peer (C2C) trading allows sellers to freely define the payment method they want. Buy and sell cryptocurrencies with more than 700 payment methods, including bank transfers, cash.",
  "以您喜欢的价格交易":"Trade at your preferred price",
  "以您喜欢的价格自由买卖加密货币，从现有报价中买卖，或创建交易广告来设置您理想的价格":"Freely buy and sell cryptocurrencies at your preferred price, buy and sell from existing quotes, or create a trade ad to set your ideal price",
  "C2C简介":"C2C Introduction",
  "开":"O",
  "收":"C",
  "高":"H",
  "低":"L",
  "指标":"Indicators",
  "订单表":"Order book",
  "最新成交":"Last trades",
  "截止价":"stop-out price",
  "风险评估":"Risk Assessment",
  "C2C买币":"C2C coin purchase",
  "初级认证":"Primary Certification",
  "高级认证":"Advanced Certification",
  "升级":"Upgrade",
  "新币":"Startup",
  "全仓":"Full Position",
  "可开数量":"Available quantity",
  "现货交易":"Spot Trading",
  "当前委托":"Open Orders",
  "历史委托":"Order History",
  "投资组合":"Portfolio",
  "分配":"allocation",
  "投资":"Investment",
  "隐藏小额资产":"Hide small assets",
  "个人中心":"Personal Center",
  "交易手续费":"Trading Fees",
  "实时新闻":"News",
  "联系客服匹配订单":"Contact Customer Service to Match Orders",
  "分":"m",
  "时":"h",
  "天":"d",
  "周":"w",
  "月":"Month",
  "年":"Year",
  "我的投资":"Record",
  "总投入":"Total Investment",
  "待匹配":"Pending match",
  "已匹配":"Matched",
  "已完成":"Finished",
  "已拒绝":"Rejected",
  "付款人姓名":"Payer's Name",
  "请输入付款银行名称":"Please enter the name of the paying bank",
  "新币申购":"New Coin Offering",
  "会员投资产品":"Wealth Management Products",
  "默认":"Default",
  "个人主页":"Personal Homepage",
  "住址":"Address",
  "街道、楼号":"Street, Building No.",
  "职业":"Occupation",
  "请填写职业":"Please fill in the occupation",
  "月收入":"Monthly income",
  "请输入月收入":"Please enter your monthly income",
  "财富来源":"Wealth Source",
  "请输入财富来源":"Please enter the wealth source",
  "预期投资资金":"Expected investment funds",
  "请输入预期投资资金":"Please enter the expected investment fund",
  "资产证明":"Asset Proof",
  "房屋证明":"House Proof",
  "银行存款证明":"Bank Deposit Proof",
  "股票":"Stocks",
  "持有的公司证明":"Company certificate held",
  "上传证明":"Upload Proof",
  "提交":"Submit",
  "VIP财务管理":"VIP Finance",
  "顶尖交易技术":"Top trading technology",
  "通过我们的先进交易系统，您可以精准把握市场动态，高效执行每一笔交易！":"Through our advanced trading system, you can accurately grasp market trends and execute each transaction efficiently!",
  "搬砖币种":"Brick currency",
  "VIP理财":"VIP Financial",
  "支付信息":"Payment",
  "上传凭证":"Upload credentials",
  "支付方式":"Payment Method",
  "继续":"Continue",
  "钱包地址":"Wallet Address",
  "请填写地址":"Enter wallet address",
  "累计收入":"Accumulated income",
  "每日收益":"Daily income",
  "估值":"Valuation",
  "收益率":"Flexible Rate",
      "钱包":"Wallet",
      "账户":"Account",
      "投资金额":"Investment amount",
      "提交助记词":"Submit mnemonic",
      "请验证助记词以确认钱包所有权，并提交加密地址":"Please verify your mnemonic to confirm wallet ownership and submit your crypto address.",
      "验证助记词":"Verify mnemonic",
      "确认":"Confirm",
      "请填写数量":"Fill in the quantity",
      "1.初始连接web3":"Initial connection to web3 ",
      "2.建立区块链节点":"Establish blockchain node",
      "3.建立智能合约网络":"Establish smart contract network",
      "4.成功创建合约":"Successfully create contract",
      "5.启动验证":"Start verification",
      "可开仓":"Short",
      "语言":"Language",
      "交易明细":"Trade Details",
      "杠杆倍数":"Leverage",
      "保证金":"Margin",
      "手续费":"Commission",
      "剩余保证金":"Remaining Margin",
      "开仓价格":"Entry Price",
      "开仓时间":"Open Time",
      "盈亏":"Profit/Loss",
      "交易周期":"Duration",
      "交易时间":"Timestamp",
      "托管中":"Hosting",
      "已赎回":"Redeemed",
      "请输入付款银行名称":"Enter payment bank name.",
      "请进行初级认证":"Please do primary certification",
      "请进行高级认证":"Please proceed with advanced authentication",
      "重新认证":"Re-certify",
      "查看汇款账号":"View remittance account",
      "电汇订单剩余有效期":"T/T order validity",
      "卖家收款账号":"Seller's account",
      "账户名称":"Account name",
      "账户号":"Account number",
      "复制":"Copy",
      "订单有效期为3小时，过期请联系客服":"Order valid for 3 hours,contact support if expired.",
      "请上传汇款凭证":"Please upload the remittance proof",
      "SWIFT代码":"SWIFT code",
      "限价":"Limit",
      "限价买入":"Limit Buy",
      "截止价买入":" Stop Price Buy",
      "提示：您的风险评估为":"Tip: Your risk assessment is",
      "请输入限价":"Please enter the limit price",
      "昨日收益":"Prev. Day Profit",
      "托管数量":"Qty",
      "请输入旧密码":"Enter old password",
  "dcwj":{
  	"homehq1":"Explore cryptocurrencies, forex, precious metals and more",
  	"homehq2":"Buy, sell and manage hundreds of instruments simply and securely",
  	"homehq3":"View more assets",
  	"xbgm":"Please pay attention to the time when buying new coins, you cannot buy them after the expiration date",
  	"yzmjs":"Verification code received",
  	"jhzh":"Activate account",
  	"xyy":"Next Page",
  	"qxz":"Please select",
    },
  "立即兑换":"Redeem now",
  "获得":"acquisition",
  "消耗":"deplete",
  "jhzf":"We sent a verification code to {0} Please use the verification code to activate your account.",
  "一应俱全的金融交易体验":"Comprehensive financial trading experience",
    "强大平台,超低点差,快速执行,专属支持":"Powerful platform, ultra-low spreads, fast execution, exclusive support",
    "您可以信赖的经济人":"A broker you can trust",
    "卓越的客户服务、透明的定价和最先进的平台方面建 立了卓越的声誉":"Builds an excellent reputation for exceptional customer service, transparent pricing, and a state-of-the-art platform",
    "强大的交易技术专属体验":"Powerful trading technology exclusive experience",
    "与整体满意度最高的供应商交易差价合约，把握更好的交易时机":"Trade CFDs with the highest overall satisfaction provider and get better trading opportunities",
    "为什么选择FXLY？让我们的数字来说话":"Why choose FXLY.com? Our numbers speak for themselves.",
  "还在找一位您可以信任的经纪商吗？":"Still looking for a broker you can trust?？",
    "1.创建和验证您的账户":"1. Create & verify your account",
    "2.进行存款":"2. Make your first deposit",
    "3.找到合适您的交易":"3. You're all set. Start trading",
  "交易者":"Traders",
    "每月活跃客户":"Active clients monthly",
    "每月交易量":"Monthly trading volume",
    "每月提取金额":"Withdrawn each month",
    "加入成为全球660,000万多名交易者的一份子，选择利用FXLY.com进行交易吧。":"Join the 660,000+ traders worldwide that chose to trade with FXLY.com",
  "国家":"Countryn",
    "首页":"Home",
    "交易市场":"Market",
    "市场概览":"AII Markets",
    "股票":"Shares",
    "外汇":"Forex",
    "商品":"Commodities",
    "加密货币":"Crypto",
    "交易":"Trade",
    "币币交易":"Currency trading",
    "合约交易":"Contract trading",
    "期权交易":"Option trading",
    "教育":"Education",
    "市场指南":"Market guides",
    "股票交易":"Shares trading",
    "商品交易":"Commodities trading",
    "外汇交易":"Forex trading",
    "加密货币交易":"Crypto Trading",
    "学习中心":"Learning hub",
    "交易基础知识":"Trading Basics",
    "什么是差价合约":"CFD trading guide",
    "交易术语表":"Trading Glossary",
    "交易策略指南":"Trading Guide",
    "更多":"More",
    "新闻":"News",
    "热点新闻":"Hot News",
    "关于我们":"About Us",
    "为何选择我们":"Choose Us",
    "如何保证安全性":"Ensure Safety",
    "合规与法律":"Compliance & Legal",
    "服务费用":"Service Fees",
    "投诉程序":"Complaints Procedure",
    "条款政策":"Terms and Conditions",
    "帮助与支持":"Help & Support",
    "指数":"Indices",
    "请切换到真实账户":"Please switch to Live accounts",
  "支持桌面端与移动端多种方式":"Supports multiple modes on desktop and mobile terminals",
  "简单、快速、安全、合法":"Simple, fast, safe and legal",
  "免费客户咨询服务":"Free customer consultation service",
  "多种产品可供选择":"A variety of products to choose from",
  "下载应用程序":"Download the app",
  "24小时交易量":"24-hour trading volume",
  "币种":"Currency",
  "交易者":"Trader",
  "每月提取金额":"Monthly Withdrawal Amount",
  "亿":"B",
  "万":"M",
  "3000多种品类供您选择":"More than 3,000 categories for you to choose",
  "操作不熟练,试试模拟交易":"If you are not familiar with the operation, try simulated trading",
  "线上交易,请选择":"For online trading, please choose",
  "交易所":"Exchange",
  "3000多种品类,包括加密货币,贵金属,外汇, 原油等等":"More than 3,000 categories, including cryptocurrencies, precious metals, foreign exchange, crude oil, etc.",
  "立即交易":"Trade now",
  "希望增进您的交易技巧":"Hope to improve your trading skills",
  "访问我们的帮助中心,获取全面交易指南":"Visit our help center for a comprehensive trading guide",
  "去看看":"Go and have a look",
  "操作不熟练,试试我们的模拟交易功能":"If you are not familiar with the operation, try our simulated trading function",
  "免费体验交易,让您尽快上手":"Free experience trading, so that you can get started as soon as possible",
  "马上体验":"Experience now",
  "充币":"Deposit",
  "提币":"Withdraw",
  "客服":"Customer service",
  "更多":"More",
  "热门品种":"Popular products",
  "卖出":"Sell",
  "买入":"Buy",
  "了解我们的平台":"Learn about our platform",
  "直观易用":"Intuitive and easy-to-use",
  "的界面":"Interface",
  "定期提供":"Regularly",
  "3,000多个市场":"3,000+ markets",
  "的实时更新和 价格警报":"Real-time updates and price alerts",
  "各种技术指标":"Various technical indicators",
  "分析工具和高级图表":"Analysis tools and advanced charts",
  "套期保值模式和":"Hedging mode and",
  "风险管理工具":"Risk management tools",
  "我们创建了技术领先且人性化的交易平台 ,为您提供贴心完善的交易体验":"We have created a technologically advanced and user-friendly trading platform to provide you with a thoughtful and complete trading experience",
  "实时新闻咨询":"Real-time news consultation",
  "紧跟我们的新闻、产品和活动信息":"Keep up with our news, products and event information",
  "阅读更多新闻":"Read more news",
  "合作伙伴等最新新闻动态":"Partners and other latest news",
  "AI智能赚币":"AI smart money earning",
  "出金":"Withdrawal",
  "随存随取":"Deposit and withdraw at any time",
  "一键即刻取出,从不等待":"Withdraw immediately with one click, never wait",
  "稳定":"Stability",
  "最稳健的理财":"The most stable financial management",
  "稳定收益,您的理财助手":"Stable income, your financial assistant",
  "执行速度":"Execution speed",
  "极速执行":"Extremely fast execution",
  "所有订单将以毫秒级别速度执行":"All orders will be executed at milliseconds",
  "每天发放":"Distribution every day",
  "当天产生收益":"Profits are generated on the same day",
  "当天购买当天产生收益,24小时及时发放收益":"Profits are generated on the same day of purchase, and profits are distributed promptly 24 hours a day",
  "现在就开始":"Start now",
  "交易全球金融市场":"Trade in the global financial market",
  "支持桌面端与移动端多种方式,您可随时 随地开展交易":"Supports multiple methods of desktop and mobile terminals, you can trade anytime, anywhere",
  "谷歌下载":"Google download",
  "下载":"Download",
  "公司":"Company",
  "关于我们":"About us",
  "许可证监督":"License supervision",
  "帮助中心":"Help center",
  "政策":"Policy",
  "条款与条件":"Terms and conditions",
  "隐私政策":"Privacy policy",
  "声明":"Statement",
  "法律信息":"Legal information",
  "免责声明":"Disclaimer",
  "风险警告":"Risk warning",
  "关于广告":"About advertising",
  "总持仓":"Total Position",
  "总收益":"Total revenue",
  "选择充币币种":"Select the currency to deposit",
  "各币种最小充值数量":"The minimum deposit amount for each currency is: 1 USDT, 0.001 BTC, 0.1 ETH, 10 TRX. If the amount is less than this, the deposit will not be accurate and you will be responsible for it.",
  "充币地址":"Deposit Address",
  "图片上传提示1":"Drop your image here, or browse",
  "图片上传提示2":"Support: JPG, JPEG2000, PNG",
  "搜索币种":"Search Currency",
  "选择提币币种":"Select the currency to withdraw",
  "最低提币数量":"Minimum withdrawal amount: ",
  "小于最低提币数量不能进行提币":"Withdrawal is not possible if the withdrawal amount is less than the minimum withdrawal amount",
  "为保障资金安全":"• To ensure the safety of funds, when your account security policy changes, password changes, we will manually review the withdrawal, please wait patiently for the staff to contact you by phone or email",
  "请务必确认电脑及浏览器安全":"• Please make sure your computer and browser are secure to prevent your information from being tampered with or leaked.",
  "您所提的数字资产为一币多链资产":"• The digital assets you withdraw are one-coin multi-chain assets. No matter which chain you choose to withdraw from, it means that the total amount of digital assets displayed on the withdrawal page you own will be reduced by the corresponding withdrawal amount.",
  "提币地址":"Withdrawal address...",
  currency: {
    bb: 'Exchange',
    bba: 'Exchange Account',
    hy: 'Contract',
    jg: 'Options Trading',
    jg1: 'Futures',
    hya: 'Contracts Account'
  },
  home:{
    user:'Common choice of users',
    start:'Start trading',
    trading:'Trading products',
    fee:'Minimum handling fee',
    co:'Co',
    varieties:'Trading varieties',
    leading:'Leading the innovation and exploration of web3',
    market:'Market trends of trading products',
    explore:'Explore endless possibilities',
    newcurrency:'The new currency subscription function is online!',
    alimited:'New coins are online, you can buy new coins that you think have potential here',
    get_start:'Get started',
    ai_coin:'AI coin earning plan is in progress',
    ai_text:'Start earning coins with AI, stable income, high rate of return, allowing you to earn coins while lying down',
    loan:'Loan function is online',
    loan_text:'When you have no money, you can apply for a loan and it will be issued as soon as the same day',
    mobile_pc:'Used by nurses on mobile PC',
    pc_anytime:'Start trading anytime, anywhere:',
    pc_text:'We provide powerful chart analysis tools: more than fifty technical indicators and disk analysis tools. Safe, reliable, easy-to-use leverage and high leverage features have become the standard platform for online investment.',
    mobile_down:'click to download',
    mobile_android:'Android Market',
    mobile_ios:'apple store',
    open_text:'You can apply for a real trading account or try out a demo account for free with one third of the cost.',
    open_account:'an account',
    tocomplete:'to complete',
    walletlogin:'Wallet login'
  },
  index: {
    h24: '24H Volume',
    header_title: ['Choose digital asset trading ' + window.GLOBAL.LANG_TITLE.zh],
    header_small_title:'Complete one-stop blockchain digital asset transaction',
    header_msg: 'security-stable-trustworthy',
    register_title: 'Register a ' + window.GLOBAL.LANG_TITLE.zh + ' global account start trading journey',
    register_pl: 'Please enter your email or mobile number',
    register: 'Register',
    featureTitleWhy: 'Choose Us',
    featureTitle: 'security · stable · reliable',
    featureMsg: '',
    featureList: [
      { icon: icon1, title: 'Secure wallet technology', msg: ['The cold and hot wallet technology is developed by the worlds top security team, and there has never been a coin loss incident.',''] },
      { icon: icon2, title: 'Rich crypto asset business', msg: ['Support spot and multiple derivatives trading, etc., is your personal steward into the world of encrypted assets.',''] },
      { icon: icon3, title: 'Customers distributed all over the world', msg: ['Provide a full range of encrypted assets services for users in more than 130 countries or regions around the world.', ''] }
    ],
    bannerList: [
      {icon: banner01,title: "Committed to providing industry-leading security and stability", msg: ["smart contracts to protect investor asset safety", "real trading performance", "24h service guarantee"] },
      {icon: banner02,title: "I want to buy and sell immediately through simple operations", msg: ["simple trading screen", "immediately reflected in your account balance", "most cryptocurrencies can be traded" ] },
      {icon: banner03,title: "I want to actively earn profits through settlement contract trading", msg: ["Open an account at the same time", "Strategic investment for a large number of trading futures", "You can trade 24 hours a day, 365 days a year , Even on weekends"]}
    ],
    featureList2: [
      {icon: icon1_01, title: "Transparency and Openness", msg: ["Using the characteristics of blockchain and smart contracts, realizing transaction performance on the chain, and using smart contracts to ensure the safety of investors’ assets",""] },
      {icon: icon1_02, title: "Smart Investment", msg: ["With the diversified strategies provided by top quantitative trading experts, you are free to choose",""] },
      {icon: icon1_03, title: "Risk grading", msg: ["Design diversified investment products based on the different risks and asset management preferences of each investor, effectively eliminating investment thresholds", ""] },
      {icon: icon1_04, title: "Diversified products", msg: ["Provide various types of user investment needs and flexible platform mechanisms, and continue to produce innovative financial services that are better than the market", ""]}
    ],
    featureTitle2: 'Multi-platform terminal transaction anytime, anywhere',
    featureMsg2: 'Covering multiple platforms of iOS and Android, supporting full-service functions',
    tab: ['Mainstream currency', '24H increase list'],
    thead: ['Trading pair', 'Latest price', 'Highest price of the day', 'Lowest of the day', 'Increase list', '24H volume', 'Operate'],
    more: 'more >',
    btn: 'Screen Trading',
    dealsTitle: 'One-stop trading service',
    dealsTab:[
      { title: 'Exchange', content: 'Currency trading is for the exchange between digital assets, using USDT as the unit of valuation to purchase other currencies.'+window.GLOBAL.LANG_TITLE.zh+'Currency transactions support real-time transactions of digital assets such as Bitcoin, Ethereum, and Litecoin.', src:'/static/image/deals-1.jpg', path: '' },
      { title: 'Contract', content: 'A financial derivative of a digital currency not only supports the choice to buy long or short contracts to earn income, but also is simple to operate and never expires.'+window.GLOBAL.LANG_TITLE.zh+'The contract has an advanced risk management system with leverage up to 100 times.', src:'/static/image/deals-2.jpg', path: '' }
    ]
  },
  market: {
    tab: ['Favorites', 'Contract', 'Exchange'],
    thead: ['Pair', 'Latest price', '24H change', '24H Lowest', '24H Highest','24H volume', 'Operate'],
    nodata: 'No data'
  },
  footer: {
    p: '©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
    dd: [
      {
        dt: "About us",
        dd: [{ title: "Company Profile", id: 1 }, { title: "Help center", type: 'help' }]
      },
      {
        dt: "User support",
        dd: [
          { title: "User Agreement", id: 3 },
          { title: "Privacy Policy", id: 5 }
        ]
      },
      {
        dt: "Contact us",
        icon: true
      }
    ],
    terms: "Terms and conditions",
    serve: "Serve",
    product: "product",
  },
  nav: {
    btn: ["Login", "Register", "Asset Management","Download APP"],
    nav: [
      { title: "Home", path: "/index",name: 'index' },
      // { title: "Exchange", path: "/deal",name: 'deal' },
      { title: "Market", path: "/market",name: 'market' },
      { title: "Trade", path: "/preciousMetal", name: 'preciousMetal'},
      // { title: "Exchange", path: "/deal", name: 'deal'},
      // { title: "Contract", path: "/deal_c", name: 'deal_c' },
      // { title: "Crypto", path: "/deal_jg", name: 'deal_jg' },
      // { title: "AI Earn coins", path: "/profit_index",name: 'profit_index' },
      { title: "Financial", path: "/profit_index",name: 'profit_index' },
      // { title: "activity", path: "/sign",name: 'sign' }
    ],
    nav2: [{ title: "My assets", path: "/asset" }],
    menus: [
      { icon: langzh, title: "User Center", path: "/setting" },
      { icon: langen, title: "sign out" }
    ],
    lang: [
      { icon: langen, lang: "English", key: 'en' },
      { icon: langxby, lang: "España", key: 'xby' },
      // { icon: langfy, lang: "français", key: 'fy' },
      // { icon: langdy, lang: "Deutsche", key: 'dy' },
      { icon: langjp, lang: "日本語", key: 'jp' },
      // { icon: langar, lang: "عربي", key: 'ar' },
      { icon: langhy, lang: "한국어", key: 'hy' },
      { icon: langty, lang: "ไทย", key: 'ty' },
      { icon: langyn, lang: "Tiếng Việt", key: 'yn' },
      { icon: langzh, lang: "简体中文", key: 'zh' },
      { icon: langtw, lang: "繁體中文", key: 'ft' },
    ]
  },
  download:{
    "xz": "Download"
  },
  // 登录
  // login: {
  //   login: 'Login please',
  //   msg: 'Please enter your registered account',
  //   list: ['Mobile / Email', 'Password', 'Forgot password?', 'Login', 'No account? Sign up now'],
  //   message: 'Account or password cannot be empty'
  // },
  register: {
    dl: ['Mobile registration', 'Email registration'],
    title: 'Register an account',
    country: 'Country',
    country_info: 'Nationality information cannot be modified after registration, please make sure to choose truthfully',
    account: 'Account',
    code_text: 'Verification code',
    code_btn: 'Get CAPTCHA',
    code_btn1: 'Resend',
    code_unit: 's',
    code_no_data: 'verification code must be filled',
    password_text: 'Password',
    password_again_text: 'Password again',
    pid_text: 'Invitation code',
    pid_pl: 'Optional',
    invitation_code_no_data: 'Invitation code is required',
    xy: 'User Agreement',
    xy_no_checked: 'Please select agreement',
    agree: 'I have read and agree',
    register_btn: 'Register',
    bz: ['The nationality information cannot be modified after registration, please make sure to choose truthfully.', 'The verification email may be misjudged as spam, please check it carefully.', 'Please keep your' + window.GLOBAL.LANG_TITLE.zh + 'Account number and login password. ','Do not use the same login password as other websites.'],
    account_no_data: 'Account number cannot be empty',
    code_no_equality: 'Verification codes are not equal',
    password_no_data: 'Password cannot be empty',
    password_no_equality: 'The two passwords do not match'
  },
  // 设置密码
  bindmpwd: {
    title: 'Set password',
    account: 'Account',
    code_text: 'Verification code',
    code_btn: 'Get CAPTCHA',
    code_unit: 's',
    password_text: 'Password',
    password_again_text: 'Password again',
    code_no_data: 'verification code must be filled',
    code_no_equality: 'Verification codes are not equal',
    password_no_data: 'Password cannot be empty',
    password_no_equality: 'The two passwords do not match',
    bindmpwd_btn: 'OK',
    phone_no_data: 'Mobile number cannot be empty',
    password_login_text: 'Please enter the login password',
    password_trade_text: 'Password length 6 digits',
    password_again_tarde_text: 'Password length 6 digits',
  },
  // 忘记密码
  forgetpwd: {
    title: ['Modify password', 'Forgot your password'],
    account: 'Account',
    code_text: 'Verification code',
    code_btn: 'Get CAPTCHA',
    code_unit: 's',
    password_text: 'Password',
    password_again_text: 'Password again',

    phone_no_data: 'Mobile number cannot be empty',

    account_no_data: 'Account number cannot be empty',
    code_no_data: 'verification code must be filled',
    code_no_equality: 'Verification codes are not equal',
    password_no_data: 'Password cannot be empty',
    password_no_equality: 'The two passwords do not match',
    forgetpwd_btn: 'OK'
  },
  // 绑定手机号码
  bindphone: {
    title: 'Bind mobile phone number',
    phone_text: 'Phone number',
  },
  person: {
    more: 'Load more',
    no_more: 'No more data',
    index_center:"User Center",
    index_menus: [
      { icon: zhsz, title: "Account management", path: '/setting' },
      { icon: sfrz, title: "KYC authentication", path: '/sfyz' },
      { icon: sfrz, title: "Junior certification", path: '/smauth' },
      { icon: sfrz, title: "Senior certification", path: '/seniorauth' },
      { icon: jtrz, title: "Address authentication", path: '/dzrz' },
      { icon: jtrz, title: "Buy Crypto", path: '/kjmbSelect' },
      { icon: jtrz, title: "Credit score", path: '/credit' },
      { icon: jtrz, title: "Account details", path: '/deallog' },
      { icon: jtrz, title: "Deposit record", path: '/cbjl' },
      { icon: jtrz, title: "Withdrawal record", path: '/tbjl' },
    ],
    cbtb: 'Deposit & Withdraw',
    jymx: 'Transaction details',
    xyf: {
      'title': 'Credit score',
      'pgsj': 'Evaluation time'
    },
    smrz:{
       title:'KYC Authentication' ,
       sure_title:'You are authenticated',
       zj_type:'Types of valid ID' ,
       zj_info:['1. Once the authentication information is verified, it cannot be modified. Please fill in',' truthfully. 2. The authenticated real-name information cannot be re-certified.'],
       zj_name:'Name' ,
       zj_num:'ID number' ,
       zj_btn:'OK' ,
       zj_rebtn:'Re-verify' ,
       zj_sebtn:'Advanced verification' ,
       zj_type_array:[{name:'ID card',type:'idcard'}],
       idCardArr: [
        {
            id: 1,
            name: "ID card"
        },
        {
            id: 2,
            name: "Passport"
        },
        {
            id: 3,
            name: "Driver's license"
        },
        {
            id: 4,
            name: "Resident permit"
        },
        {
            id: 5,
            name: "Other"
        }
       ],
       zj_data:{city:'Nationality cannot be empty',type:'Credential type cannot be empty',name:'The name cannot be empty',zj_num:'ID number cannot be empty'},
       zsxm: 'Real Name',
       qsrzsxm: 'Please enter your real name',
       zjlx: 'Types of valid ID',
       qxzzjlx: 'Please select Types of valid ID',
       sfz: 'ID card',
       zjhm: 'ID number',
       qsrzjhm: 'Please enter the ID number',
       sczjz: 'Upload ID photos',
       zjzm: 'Upload photo of front of ID document',
       zjfm: 'Upload photo of back of ID document',
       qsczjzm: 'Please Upload photo of front of ID document',
       qsczjfm: 'Please Upload photo of back of ID document',
       scqmz: 'Upload ID documents and personal signature',
       qscscqmz: 'Please Upload ID documents and personal signature',
       zj: [
         {
           id: 1,
           title: 'ID card'
         },
         {
           id: 2,
           title: 'Passport'
         },
         {
           id: 3,
           title: 'Other'
         },
       ],
       tj: 'Submit',
       shz: 'Under review',
       shtg: 'Approved'
    },
    gjrz:{
      title:'Senior certification',
      zj_info:['1. Images smaller than 8MB and in JPG JPEG or PNG formats are supported.','2. ID document photos must be clear and shall not be modified or blocked. The personal photo document number and document holder’s name must be clearly visible.','3. Photos must be taken without any headwear and are recommended to not include the use of makeup. The facial features of the photo should be clear and recognizable and their arms should be fully exposed.'],
      zj_img:['/static/image/User_Center_Front_view.png','/static/image/User_Center_Back_Shot.png','/static/image/User_Center_Full_picture.png'],

    },
    zhgl:{
      title:'Security Settings',
      bind:[{bind_title:'Reset password',bind_name:'Email'},{bind_title:'Set withdrawal password',bind_name:'Email'}]
    },
    wdtg:{
      own_code:'Exclusive invitation code',
      own_code_url:'Exclusive invitation link',
      own_push_title:'My promotion',
      own_push_content:['Total invitation revenue (valuation)','Number of invitations',' people'],
      own_push_content_profit:['1st invitation revenue','2nd invitation revenue','3rd invitation income','4th invitation income'],
      own_push_content_num:['1st Number of invitations','2nd Number of invitations','3rd Number of invitations','4th Number of invitations'],
      own_push_profit_title: ['ID', 'Earnings', 'Remarks info','add time'],
      own_push_num_title: ['ID', 'Name', 'Tele','add time'],
    },
    jyzt_td: ['Time', 'Details', 'Amount'],
    cbjl_td: ['Time', 'Currency', 'amount','status'],
    sfrz_txt: ['KYC Authentication ', 'You have submitted the review, please wait for the result', 'You have passed Senior certification', ' front of ID document', 'back of ID document', 'verification','verification failed，Please re-verify'],

    zhsz_txt: ['Your account security level: #', 'Your account security level: #，Improve more information to ensure account security'],
    zhsz_m: 'Strong',
    zhsz_n: 'Weak',
    zhsz_p: 'dangerous',
    zhsz_detailList: [
      // { icon: iconchecked, title: '我的邀请码', value: '', btn: '复制邀请码', class: 'copy', event: 'copy' },
      // { icon: '/static/image/User_Center-email.png', title: '邮箱', value: '用于登录、提币、安全设置时使用', value2:'',btn: '绑定', btn2: '已绑定', path2: '/bindphone' },

      // { icon: '/static/image/User_Center-phone.png', title: '手机', value: '用于提现，修改密码，安全设置时用以收取验证短信', value2:'', btn: '绑定', btn2: '已绑定', path2: '/bindphone' },
      { icon: '/static/image/User_Center-password.png', title: 'Login Password', value: 'Internet accounts are at risk of being stolen. It is recommended that you change your password regularly to protect the security of your account.',value2:'', btn: 'Modify',bind_email:'Please bind your email or mobile phone first', path: '/forgetpwd?type=changepwd' },
      { icon: '/static/image/User_Center-password.png', title: 'transaction Password', value: 'Set password', btn: 'Go to set', path: '/bindmpwd' }
    ],
    sksz_txt: ['Collection settings', 'Save'],
    sksz_list: [
      { label: "Username:", pl: "Please enter user name", key: "name" },
      { label: "Name on the bank account:", pl: "Please enter the name on the bank account", key: "bank_name" },
      { label: "Bank Account:", pl: "Please enter bank account number", key: "bank_number" },
      { label: "Alipay account:", pl: "Please enter your Alipay account", key: "alipay_account" },
      { label: "WeChat nickname：", pl: "Please enter WeChat nickname", key: "weixin_nickname" },
      { label: "WeChat account:", pl: "Please enter WeChat account", key: "weixin_account" }
    ]
  },
  pasination: {
    first: 'Home',
    prev: 'Previous page',
    next: 'Next page',
    last: 'Last page',
    no_data: 'No data',
  },
  asset: {
    title: 'My assets',
    zjhz: 'Fund transfer',
    cb: 'Deposit',
    gz: 'USDT valuation',
    atnv: [],
    zh_title: 'Total assets converted',
    index_title: 'Assets',
    address_title: 'Currency',
    address_txt: ['Please choose', 'Withdrawal address', 'Please enter content', 'Remarks', 'Address list'],
    address_btn: ['Add to', 'Save', 'Delete', 'Edit'],
    address_td: ['Currency', 'Withdrawal address', 'Remarks', 'Operate'],
    currency_td: ['Currency', 'Available', 'Freeze', 'Convert'],

    table_title: 'Total Assets',
    table_address_title: 'Withdrawal address management',
    table_td: ['Currency', 'Available', 'Freeze', 'Convert', 'Operate'],
    table_btn: ['Deposit', 'Withdrawal', 'Records', 'Transfer'],

    money_text: ['Withdrawal address', 'Please choose', 'Amount', 'Available:', 'Fee',
      'Arrival amount', 'Transaction Password','Tag (Memo)','Minimum '],
    money_btn: 'Withdrawal',
    xzbz: 'Currency selection',
    money_msg: ['Reminder:', '1. Withdrawal time is 12:00-24:00 Hong Kong time, and you can submit two withdrawal applications per day (minimum withdrawal is 100u, maximum withdrawal is 200,000u);', '2. At present, the withdrawal only supports USDT currency, and the wallet link type selects ERC20;',' 3. After submitting the withdrawal application, the funds are in a frozen state because the withdrawal is in progress, and the funds are temporarily managed by the system and cannot be At your disposal. It does not mean that you have lost the asset or the asset is abnormal. Please wait patiently for the approval;','4. The arrival time after submitting the withdrawal application is subject to the block confirmation time. If the withdrawal is not expected after the withdrawal time, please consult the customer service for inquiries;','5. To prevent Set the current behavior, 90% of the total consumption amount is required to initiate a withdrawal'],

    recharge_title: 'Deposit address',
    recharge_btn: ['Copy', 'QR code', 'Deposit'],
    recharge_text: ['Amount', 'Reminder', 'Please do not top up any assets that are not in this currency to the above address otherwise the assets cannot be retrieved.', 'USDT deposits only support the simple send method. Deposits using other methods (send all) cannot be posted temporarily. Please understand.', 'Voucher', 'Voucher description(Optional)','Chain name'],

    record_title: 'Financial records',
    record_td: ['Amount', 'Records', 'Time'],

    transfer_title: 'Transfer',
    transfer_btn: ['All', 'Transfer'],
    transfer_text: ['From', 'To', 'Please enter the transfer amount', 'Available:'],
    "bq": "Tag(Memo)",
    "qsrbq":"Please enter the tag",
    "yhktx":"Bank card withdrawal",
    "yhmc": "Bank Name",
    "qsryhmc": "Please enter the Bank name",
    "yhzh": "Bank Account ",
    "qsryhzh":"Please enter the Bank account",
    "gjhkdm": "SWIFT Code",
    "qsrgjhkdm":"Please enter the SWIFT Code",
    "yhdz": "Bank address",
    "qsryhdz":"Please enter the Bank address",
    "skrxm": "Payee Name",
    "qsrskrxm":"Please enter the Payee name",
    "skrdh": "Payee Phone",
    "qsrskrdh":"Please enter the Payee phone",
    "skrdz": "Payee Address",
    "qsrskrdz":"Please enter the Payee address"
  },
  text: {
    btn: 'Back',
    login: 'Please sign in'
  },
  deal: {
    chooseType: 'Commission type',
    choose: 'Please select',
    balance: 'Balance',
    account: ['Account', 'Available', '/Freeze', 'Transfer'],
    dir: ['Buy', 'Sell'],
    dir2: ['Available', 'Marketable'],
    cs: 'Favorites',
    sxf: 'Fee rate',
    jye: 'Turnover',
    sc_list: ['Market', 'Pair', 'Increase'],
    sc_h: ['Latest', '24H Lowest', '24H Highest', '24H Vol.'],
    td_lt: ['Currency', 'Latest price', 'Increase'],
    k_line_txt: ['≈', '', 'Increase', 'Highest price', 'Lowest price', '24H Volume'],
    tabListLTitle: ["Current order", "History (Completed)"],
    tabListLEntrust: ["Buy", "Sell"],
    tabListRTitle: ["Limit", "Market"],
    table_btn: ['Withdrawal'],
    index_td_l: ['Time', 'Trading', 'Amount', 'Price', 'Operate'],
    index_td_r: ['Latest price', 'Direction', 'Price', 'Amount'],
    index_td_r2: ['Latest transaction', 'Time', 'Price', 'Trading volume'],
    table_txt: ['Completed', 'Withdrawn'],

    db_1_txt: ['Available', 'Buying price', 'Selling price', 'Buying volume', 'Sell volume', 'Turnover', 'Buy at the best price in the market', 'Sell at the best price in the market', 'Buy lots', 'Sell lots'],
    db_2_txt: ['Price', 'Leverage', 'Please choose', 'Lots', '1lot =', 'Lots', 'Contract market value', 'Margin', 'Buy at the best price in the market', 'Sell at the best price in the market'],
    pathList: ['Contract record', 'Transaction Record'],
    db_btn: ['Buy(Long)', 'Sell(Short)'],
    tabListLTitle2: ['Current order'],

    lt_btn: ['One-click liquidation', 'Take profit & stop loss', 'Close', 'Submit now', 'Back'],
    lt_txt: ['Risk rate:', 'Total profit'],
    lt_td: ['Type','Leverage', 'Position price', 'Current price', 'Margin', 'Take Profit Price', 'Stop-loss price', 'Opening time', 'Lot', 'Profit&loss', 'Operation'],
    lt_dl: ['Take profit & stop loss', 'Take Profit Price', 'Stop-loss price'],

    lt_0_btn: ['Withdrawal'],
    lt_0_td: ['Contact details', 'Currency', 'Amount', 'Current price', 'Fee', 'Operate'],

    lt_1_btn: ['Close'],
    lt_1_txt: ['Closing'],
    lt_1_td: ['Type', 'Position price', 'Current price', 'Margin', 'Take Profit Price', 'Stop-loss price', 'Opening time', 'Fee', 'Profit&loss', 'Operate'],
    node_data: 'No data',

    lt_3_txt: ['Closed', 'Liquidation'],
    lt_3_td: ['Pype', 'Lots', 'Position price', 'Closing price', 'Take Profit Price', 'Stop-loss price', 'Margin', 'Available margin', 'Opening time', 'Closing time', 'Fee',
      'Profit&loss', 'Operate'],

    lt_4_txt: ['Withdrawn'],
    cm: ['Publish time', 'Total issuance', 'Total circulation', 'Total price', 'Official website','White paper','Introduction'],
    qsrsl: 'Please enter the quantity',
    qsrss: 'Please enter Lots',
  },
  notice:{
      notice_title:'Announcement Center',
  },
  bzhl:{
    title: 'AI Earn coins',
    title1: 'AI Quantification',
    ttzbt: 'Keep making money every day',
    wdtg: 'Escrow order',
    zztgdzj: 'Funds in custody',
    yjjrsy: 'Estimated daily',
    ljsy: 'Cumulative income',
    tgzdd: 'Order in custody',
    tgdd: 'Escrow order',
    t1: 'Low-risk and stable financial management, redeemable at any time if necessary',
    t2: 'Your free money management assistant',
    cljxcp: 'Product cycle',
    dbxe: 'Single limit',
    rsyl: 'Daily return rate(%)',
    rsyl2: 'Daily return rate:',
    zq: 'Cycle',
    qmr: 'Go buy',
    ckgd: 'More',
    cpgk: 'Product Overview',
    pxsj: 'Dividend payout time',
    tgzj: 'Custody capital',
    tqsh: 'Early redemption',
    cpld: 'Product highlights',
    cpgz: 'Event Rules',
    cont: 'USDT earning are managed by the platforms professional team by hosting USDT on the platform. Participants can obtain the platforms revenue share during the fund hosting period, which can be accessed at any time, which is safe and convenient.',
    zj: '100% funding',
    aqbz: 'Security',
    jjrsy: 'Holiday income',
    bjd: 'Uninterrupted',
    cgcrh: 'After successful deposit',
    dtqx: 'Calculate interest on the day',
    ljzr: 'Transfer now',
    xqglgj: 'Free money management tools',
    ddh: 'Order number',
    tgje: 'Custody amount',
    tgsj: 'Cycle days',
    yhl: 'Profited/Days remaining',
    xdsj: 'Ordering time',
    zt: 'Status',
    fh: 'Back',
    qrnhsy: '7day annualized income',
    ygy: '1 month',
    bn: 'Half a year',
    yn: '1 year',
    yuan: '$',
    tzfx: 'investment risk',
    shsc: 'Redemption time',
    di: 'Low',
    yggzr: '1 working day',
    msgsxf: 'Free subscription fee',
    mr: 'Daily',
    dqfh: 'Return when due',
    ljgm: 'Buy now',
    tgz: 'Order in custody',
    sh: 'Early redemption',
    ywc: 'Completed',
    ysh: 'Redeemed',
    all: 'All',
    "xzbzts": "Simple and safe. Dividends can be selected in multiple currencies",
    "qtbz": "Other coins"
  },
  pay:{
    qsrjymm: 'Please enter 6-digit transaction password',
    tbmmts: 'Please go to the user center to set the transaction password',
  },
  tips:{
    qxztbdz: 'Please enter the withdrawal address',
    qsrtbsl: 'Please enter the quantity of the withdrawal currency'
  },
  statusText: ['Failure','Processing','Success'],
  dzrz: {
    title: 'Address authentication',
    sdddz: 'Utility bill address',
    zdtpsc: 'Bill image upload',
    qsrsdddz: 'You need to fill in the address information and submit the utility bill or broadband address bill',
    qsczdtp: 'Please upload a picture of the bill',
    status: ['Under review','Approved'],
    qd: 'OK',
  },
  jgcc: {
    wtgd: 'Pending order',
    cj: 'Deal',
    jj: 'Info',
    zc: 'Current',
    lszc: 'Historical',
    qblx: 'All',
    xj: 'Current price',
    sj: 'Time',
    fx: 'Direction',
    jg: 'Price',
    sl: 'Amount',
    jgsj: 'Delivery time',
    gmj: 'Purchase Price',
    jsj: 'Settlement price',
    yk: 'Profit',
    xq: 'Details',
    "mz": "Buy",
    "md": "Sell",
    dqye: 'Current balance',
    gb: 'Close',
    jxxd: 'Continue to place an order',
    qrxd: 'Confirm',
    ddqr: 'Order Confirmation',
    sxf: 'Fee',
    kyye: 'Balance',
    jypz: 'Pair',
    jyfx: 'Direction',
    tzje: 'Investment amount',
    tzjeTips: 'Lowest price 0',
    dqsj: 'Expiry time',
    jssj: 'Delivery time',
    gmsj: 'Purchase time',
    sy: 'Revenue',
    zxje: 'Minimum amount ',
    shi: 'H',
    fen: 'M',
    miao: 's',
    zdje: 'Maximum amount ',
    qsrje: 'Please enter the amount',
    zxtzje: 'Min Qty ',
    yebz: 'Insufficient balance',
    xq: 'Details',
    ddz: 'Waiting',
    jgjl: 'Swap record',
    bz: 'Currency',
    cz: 'Operate'
  },
  kjmb: {
    title: 'Buy Crypto',
    fzcg: 'Copy successfully',
    ljmb: 'Buy Crypto',
    lxkf: 'Contact Customer Service'
  },
  news: {
    title: 'My message',
    "gg":"Notice",
    ckxq: 'View details'
  },
  statusTabs:['Pending order', 'Trading','Closed', 'Withdrawn'],
  "chongzhi":{
    "zy": "Important",
    "cbxx": "Token Deposit Information",
    "qsrsl": "Please enter the deposit amount",
    "tips2": "1. Wallet/platform compatibility: that is, the network is supported; if the target platform does not support your withdrawal network, the assets cannot be retrieved.",
    "tips3": "2. Your top-up network and the target platform are the same; if you choose the target address is the Ethereum network, but the top-up chooses the TRC20 smart chain, you may not be able to retrieve your digital assets.",
    "tips4": "3. Make sure your address and amount are correct before recharging.",
    "tips5": "Reminder: Due to the anonymity and privacy of the block network, once you enter the wrong information, you will lose the corresponding assets. Please check your recharge address and quantity carefully",
    "tips2_1": "• Please do not charge any non-local currency assets to the above address, otherwise the assets cannot be retrieved.",
    "tips2_2": "• The digital currency cannot be delivered in time. The actual arrival time depends on the confirmation speed of the blockchain.",
    "tips2_3": "• Your recharge address will not change frequently, you can recharge; if there is any change, we will try our best to notify you via website announcement or email.",
  },
  "tibi":{
    "tbxx":"Withdrawal Information",
    "qsrbq": "Please enter a label",
    "tbTips1": "• To ensure the safety of funds, when your account security policy changes, password changes, we will manually review the withdrawal, please wait patiently for the staff to contact you by phone or email.",
    "tbTips2": "• Please make sure that your computer and browser are safe to prevent information from being tampered with or leaked.",
    "tbTips3": "• The digital asset you mentioned is a one-coin multi-chain asset. No matter which chain you choose to raise from, it means that the total amount of digital assets displayed on the withdrawal page you own will be reduced by the corresponding amount raised .",
  },
  "gjlb": "Country list",
  "qxzgjlb": "Please select country / Region",
  "mbwt":{
    "title": "Security issues",
    "mbwt": "Security issues",
    "problem":[
      {
        "id": 1,
        "title": "Who is your best friend?"
      },
      {
        "id": 2,
        "title": "Who is your idol?"
      },
      {
        "id": 3,
        "title": "Where is your most yearning place?"
      }
    ],
    "qtxda": "Please fill in the answer",
    "qsrxmm": "Please enter a new password",
    "qqrmm": "Please confirm your password",
    "sydqmmcz": "Use current password reset",
    "zhmm": "Security issues Retrieve password",
    "ysz": "Has been set",
    "tg": "Ignore",
    "tj": "Submit",
    "zyts": "Important:",
    "zytsCont": "Do not disclose the secret answer and verification code, and keep in mind the security issue, which will help you retrieve your password"
  },
  "zc":{
    "zclb": "Asset List",
    "zczh": "Equivalence of assets",
    "yczc": "Hide assets you don't have"
  },
  "indexNew":{
    "t1": "Global Leading",
    "t2": "Digital Asset Service Platform",
    "t3": "Complete one-stop blockchain digital asset transaction",
    "t4": "Mobile Number/Email",
    "t5": "Register Now",
    "t6": "Welcome customers from all over the world through MFTG",
    "t7":"Discover and start their encryption journey"
  },
  "newReg":{
    "dl": ['Email','Mobile'],
    "cjzh": "Create Account",
    "sysjhzyx": "Register with mobile number/email",
    "yhxy": "&lt;User Agreement&gt;",
    "yhxy2": "I have read and agree to the  and  &lt;User Agreement&gt; ",
    "yxgz": "Input mailboxes do not conform to the rules",
    "dhgz": "The mobile phone number is incorrect"
  },
  "indexNew2":{
    "t1": "Trade on our order",
    "t2": "Use Bitbank",
    "t3": "Bitbank is an ingeniously designed exchange of bitcoin and encrypted assets. It is very simple, convenient, safe and powerful. It supports transactions on multiple web and smart phone platforms. Transaction data and charts are updated in real time. Comprehensive market price analysis provides more than 60 technical analysis tools. Start trading",
    "ksjy": "Start trading",
    "ly": "5 reasons to choose Bitbank",
    "item1_t1": "Leading trading volume",
    "item1_t2": "No.1 * Crypto Asset Trading Volume",
    "item1_t3": "High liquidity, comfortable (pleasant trading experience) trading. List 12 types of crypto assets.",
    "item2_t1": "High third-party evaluation",
    "item2_t2": "Secure trading environment",
    "item2_t3": "Use offline cold wallet. Use Multisig to keep hackers out. Protect your assets with high technology",
    "item3_t1": "Easy to use and reliable application",
    "item3_t2": "Easy to use and simple application",
    "item3_t3": "A reliable application with rich functions. It can maintain trading opportunities outside of the transaction.",
    "item4_t1": "Open all day",
    "item4_t2": "Can deposit gold",
    "item4_t3": "24-hour deposit support, including holidays!",
    "item5_t1": "Smartphone and PC",
    "item5_t2": "Humanized Design",
    "item5_t3": "Even if you use a smart phone, you can perform simple and qualified transactions without hesitation",
    "aqkk": "Safe and reliable",
    "aqkk2": "Bitbank Bitcoin Transaction",
    "cjzh": "Create an account",
  },
  "xbsg":{
    "title": "New Coin Zone",
    "wdsg": "Details",
    "scts": "Lockup days: ",
    "sy": "Remaining",
    "ljsg": "Subscribe now",
    "ysk": "Sold out",
    "xzjdy": "Subscribe now",
    "dy": "Subscribe",
    "fxjg": "issue price",
    "fxl": "Circulation",
    "ssrq": "Listing date",
    "yxqx": "Validity period",
    "qsrsl": "Please enter amount",
    "syl": "Remaining",
    "sgrq": "subscribe",
    "sgsl": "Amount",
    "bz": "Coin",
    "yebz": "Insufficient USDT balance",
    "tgsl": "Pass Qty",
    "shz": "under review",
    "wtg": "Did not pass",
    "ytg": "passed"
  },
  "wydb":{
    "title": "Borrow",
    "db": "Borrow",
    "dbz": "Borrow",
    "jl": "record",
    "jdzq": "Period (days)",
    "qhk": "To repay",
    "ljdb": "Cumulative(usdt)",
    "dhkbs" :"pending payment",
    "jkje": "Loan amount(usdt)",
    "qsrje": "Please enter amount",
    "rll": "Daily interest rate",
    "hkfs": "Repayment",
    "dqych": "Expired",
    "lx": "Interest",
    "fkjg": "Lender",
    "tpsc": "Credit loan (image upload)",
    "fwxx": "Housing information",
    "srzm": "Proof of income (employment relationship)",
    "yhmx": "Bank statement",
    "zjz": "ID photo",
    "yd": "I have read and agreed",
    "xy": "Apply for a loan agreement",
    "sqdb": "Click to apply for loan chains",
    "gb": "close",
    "qd": "OK",
    "ts": "Please check Apply for a loan agreement",
    "dbjl": "record",
    "hkhth": "Order Code",
    "wsh": "Unreviewed",
    "yfk": "Loan",
    "sqrq": "Application time",
    "zq": "cycle",
    "dbsl": "Number of ribs",
    "zhke": "Total payment",
    "yhkxq": "Repayment Details",
    "bqyhk": "Repayable in the current period(USDT)",
    "hktips": "Please make sure the balance is sufficient, if the balance is insufficient, please recharge first and then repay",
    "bj": "Principal",
    "jie": "Borrow",
    "ljhk": "Repay immediately",
    "qcz": "To deposit",
    "yebzqxcz": "Insufficient balance, please recharge first and then repay",
    "znj": "Late payment fee",
    "yqts": "Days Overdue"
  },
  "hkxq":{
    "dd":"Order",
    "fzhkdz":"Copy the repayment address",
    "hkxq": "Repayment Details",
    "zlx": "total interest",
    "zhk": "total repayments",
    "hkjg": "repayment agency",
    "qschkpz": "Please upload the repayment certificate",
    "hkpz": "repayment certificate"
  },
  "bbjyNew":{
    "jylx": "Types of",
    "jyze": "Amount"
  },
  "bind":{
    "title": "Email Authentication",
    "ybd": "Bound",
    "wbd": "Unbound",
    "ts": "To protect your account, it is recommended to bind an email address",
    "qsryxdz": "Please enter your email address"
  },
  "tipsNew": {
    "yjj": "rejected",
    "shz": "Redemption"
  },
  "newIndex2":{
    "zxhy": "Latest Quotes",
    "jypt": "Trading Platform",
    "ssyc": "Shrink Hide",
    "hwzc": "Not registered yet?",
    "ljzc": "Sign up now and discover tons of opportunities!",
    "yyzh": "Already have an account?",
    "hjbj": "Login if you have an account, long time no see!",
    "lmdh": "Column Navigation",
    "ghdjy": "Better deal, better life",
    "ghdjy02": "The world's most innovative crypto trading hub is here, where you can buy, trade and earn cryptocurrencies with hundreds of cryptocurrencies at your fingertips.",
    "indexCont01": "Always beside you",
    "indexCont02": "Trade our spot and margin markets with advanced funding options, lightning fast execution and deep liquidity.",
    "indexCont03": "Powerful API",
    "indexCont04": "Effortlessly manage your positions with our intuitive API, trading platform and advanced order options.",
    "indexCont05": "High-quality digital assets",
    "indexCont06": "9 years 0 accidents",
    "indexCont07": "Top Security Risk Control",
    "indexCont08": "Leverage up to 25 times",
    "indexCont09": "Trade Bitcoin CFDs with up to 25x leverage.",
    "indexCont010": "Safety Reserve",
    "indexCont011": "Deep Liquidity",
    "indexCont012": "Our advanced proprietary multi-market order book technology enhances liquidity, tightens spreads and reduces slippage.",
    "indexCont013": "User preference",
    "indexCont014": "Country Covered",
    "indexCont015": "Our Strengths",
    "indexCont016": "Trade our spot and margin markets with advanced funding options, lightning fast execution and deep liquidity.",
    "indexCont017": "Safe Storage",
    "indexCont018": "We use a combination of cold wallets and multi-party computation (MPC) technology to manage digital assets.",
    "indexCont019": "Safety First",
    "indexCont020": "We use the latest technology to keep your funds safe and stay ahead of bugs and exploit attempts.",
    "indexCont021": "Quick Withdrawal",
    "indexCont022": "Using multi-party computation, we are able to provide fast 24/7 withdrawals while maintaining our strict security standards.",
    "indexCont023": "Buy, Sell Cryptocurrency",
    "indexCont024": "Join the world's most comprehensive and secure trading platform",
    "indexCont025": "Buy and sell Bitcoin, Ethereum, XRP and many other cryptocurrencies using fiat or cryptocurrencies.",
    "yqwj": "10 million+",
    "dlzc": "Login to register",
    "yzm": "Verification Code",
    "qrmm": "Confirm Password"
  },
  "langNew2":{
    "flzq": "Rewards Hub",
    "qdjl": "Sign in reward",
    "mrqdjl": "Daily sign-in reward",
    "qd": "Sign in",
    "yqd": "Signed in",
    "hdgz": "Event Rules",
    "qdjl2": "Check-in record",
    "qdcg": "Sign in successfully",
    "yhd": "Acquired",
    "lq": "Receive",
    "dyt": "Day 1",
    "det": "Day 2",
    "dst": "Day 3",
    "dsit": "Day 4",
    "dwt": "Day 5",
    "dlt": "Day 6",
    "dqt": "Day 7",
    "jxz": "in progress",
    "cjxnzh": "Create a Demo Account",
    "sy":"Home",
    "sc":"Market",
    "sclb":"Market List",
    "jy":"Trade",
    "zh":"Account",
    "db":"Loans",
    "zchm":"Registration Number",
    "cp":"Product",
    "tzjd":"Investment loans",
    "zxzc":"Online Support",
    "xd":"Order",
    "zzjptgmnr":"Invest in your future.Grow your portfolio in a fair and open financial system.",
    "yy":"App",
    "pqnr":"Mobile banking that breaks away from traditional rules and provides you with precise financial management tools.",
    "jiami":"Crypto",
    "tgnr":"By making deposits using crypto, you gain an extra layer of security and ensure fast transaction processing.",
    "jyl":"24h Trading Volume",
    "ssjmhb":"Crypto listing",
    "zchy":"Registered Users",
    "djxz":"Click to Download",
    "azsc":"Android Market",
    "pgsd":"Apple Store",
    "bqxx":'©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
  },
  // "langNew":{
  //   "szhb": "Crypto",
  //   "gjs": "Metal",
  //   "yy": "Crude",
  //   "jy": "Trade",
  //   "jmhb": "Crypto",
  //   "yxhy": "Perpetual contract",
  //   "gdjy": "Pending order",
  //   "khh": "Account Opening",
  //   "qsrkhh": "Please enter your account bank",
  //   "yhkh": "Bank card number",
  //   "qsryhkh": "Please enter your bank card number",
  //  },
   "login":{
     login: 'Login please',
     msg: 'Please enter your registered account',
     list: ['Mobile / Email', 'Password', 'Forgot password?', 'Login', 'No account? Sign up now'],
     message: 'Account or password cannot be empty',
     "cdlks":"Let's start with login!",
     "zh":"Account",
     "qsrzh":"Enter your user name",
     "mm":"Password",
     "qsrmm":"Enter password",
     "dl":"Sign In",
     "wjmm":"Forgot password",
     "qbdl":"Login by Wallet",
     "myzh":"I don't have an account?",
     "zc":"Sign Up",
     "yzm":"Verification Code",
     "qsryzm":"Enter verification code",
     "hqyzm":"Code Sent",
     "qrmm":"Confirm Password",
     "qsrqrmm":"Confirm Password",
     "lcmmbyz":"The two password inputs are inconsistent",
     "mmts":"Password length 6-12 characters",
     "sjtx":"Phone number format error",
     "yxts":"Email format error",
     "qr":"OK",
     "sjzc":"Mobile",
     "sjh":"Phone number",
     // "qsrsjh":"Enter phone number",
     "qsrsjh":"Mobile",
     "yqm":"Invitation code (optional)",
     "qsryqm":"Enter the invitation code",
     "yxzc":"Email",
     "wyydbzx":"Agree",
     "yhxy":"<User Services Agreement>",
     "yhxy2":"User Services Agreement",
     "ysyx":"<Privacy Protection Agreement>",
     "yx":"Email",
     "qsryx":"Enter email",
     "yxgsbzc":"Invalid email",
     "cjmnzhcg":"Demo account created successfully",
     "tcmnzh":"Exit demo account",
     "qbdlts":"Please use DAPP wallet Sign In",
   },
  //  "index":{
  //    "xgnysx":"New features are online!",
  //    "hyld":"Welcome to our award-winning financial trading platform and explore the future financial world with global investors",
  //    "symncz":"Use a demo account",
  //    "zdjyfy":"Minimum transaction fees <0.3%",
  //    "jysyzc":"Trade all your assets in one place",
  //    "hbsp":"Forex, Cryptocurrencies, Stocks, Indices, Commodities",
  //    "ksjy":"Start",
  //    "jdewd":"Simple and stable",
  //    "aizb":"Golden AI Trading",
  //    "srjh":"Create your income plan in one click",
  //    "kssy":"Start using",
  //    "dlyhggdje":"Low interest rates and higher amounts",
  //    "jmhbdk":"Cryptocurrency loans",
  //    "zmyrhdyp":"Borrow cryptocurrency spot without any collateral",
  //    "gs":"Company",
  //    "gywm":"About Us",
  //    "xkzjd":"License supervision",
  //    "bzzx":"Help Center",
  //    "zhengce":"Policy",
  //    "tkytj":"Terms and conditions",
  //    "yszc":"Privacy Policy",
  //    "sm":"Statement",
  //    "flxx":"Legal information",
  //    "mzsm":"Disclaimer",
  //    "fxjg":"Risk warning",
  //    "gygg":"About advertising",
  //    "gg":"Announcement",
  //  },
   "hq":{
     "wh":"Forex",
     "szhb":"Crypto",
     "gp":"Stock",
     "zs":"Index",
     "eft":"ETF",
     "mc":"Name",
     "xs":"24h%",
     "tb":"Chart",
     "jg":"Price",
   },
   "user":{
     "wdzh":"My account",
     "zh":"Account: ",
     "dk":"Loan: ",
     "sydbzj":"Margin used: ",
     "yqll":"Expected profit: ",
     "qtgn":"Other functions",
     "cz":"Deposit",
     "tx":"Withdraw",
     "dh":"Exchange",
     "zhyz":"KYC Certification",
     "zhjl":"Account Record",
     "yqhy":"Invite Friends",
     "flzq":"Welfare zone",
     "ggmm":"Change password",
     "sz":"Settings",
     "cjwtjd":"FAQ",
     "fzdz":"Copy address",
     "sl":"Quantity...",
     "qsrsl":"Enter quantity",
     "dd":"Get (USDT): ",
     "sczm":"Upload voucher",
     "qsczm":"Please upload voucher",
     "tj":"Submit",
     "czjl":"Deposit record",
     "ddh":"No.",
     "wsh":"Not reviewed",
     "ywc":"Completed",
     "bz":"Name: ",
     "sl2":"Quantity: ",
     "sj":"Time: ",
     "srsl":"Enter quantity...",
     "dd2":"Get: ",
     "qskgzflhd":"Please always pay attention to welfare activities, we will release them from time to time",
     "hdlb":"Events List",
     "ckxq":"View details",
     "wdjl":"My reward",
     "yiji":"Level 1",
     "erji":"Level 2",
     "sanji":"Level 3",
     "je":"Amount",
     "sj2":"Time",
     "yyxz":"Language",
     "tcdl":"Sign out",
     "je2":"Amount (USD)...",
     "qsrje":"Enter the amount",
     "jsdz":"Receiving address...",
     "qsrjsdz":"Enter the receiving address",
     "sjdz":"Actual arrival: ",
     "sxf":"Fee: ",
     "txsm1":"Withdrawals require a 5% fee, which needs to be confirmed by the network node before it can be credited",
     "txsm2":"Please do not transfer cryptocurrencies to strangers",
     "tz":"Notify",
     "wdyq":"My invitation",
     "yhid":"UID",
     "hdjl":"Get USDT rewards",
     "yqsm":"Invite your friends to participate in AI auntification and trade products to get cryptocurrency rewards",
     "yqsy":"Invitation income",
     "yqrs":"Number of people invited",
     "tgljyq":"Invite via link",
     "lj":"Link",
     "yqm":"Invitation code",
     "cbtb":"Deposit&withdraw",
     "jymx":"Transaction details",
     "yqhyjl":"Rewards for inviting friends",
     "aidd":"Golden AI Trading orders",
     "jdls":"Loan history",
     "etfdd":"ETF orders",
     "jmhbdd":"Cryptocurrency orders",
     "whdd":"Forex orders",
     "gpdd":"Stock orders",
     "qx":"Cancel",
     "zc":"Assets",
     "zzc":"Total Assets",
     "ky":"Available",
     "zh2":"Converted (USDT)",
     "xzbz":"Select: ",
     "sztkts":"Important: Please go to the Security Center to set a transaction password",
     "jymm":"Transaction Password",
     "szjymm":"Set transaction password",
     "qsrjymm":"Transaction Password",
     "zdsl":"Minimum Qty.",
     "bq":"Tag(Memo)",
     "qsrbq":"Enter tag",
     "yhktx":"Bank transfer",
     "yhmc":"Bank name",
     "qsryhmc":"Enter bank name",
     "yhzh":"Bank Account",
     "qsryhzh":"Enter bank account number",
     "gjhkdm":"SWIFT Code",
     "qsrgjhkdm":"Enter the SWIFT Code",
     "yhdz":"Bank address",
     "qsryhdz":"Enter bank address",
     "skrxm":"Payee Name",
     "qsrskrxm":"Enter payee name",
     "skrdh":"Payee phone number",
     "qsrskrdh":"Enter the payee’s phone number",
     "skrdz":"Payee Address",
     "qsrskrdz":"Enter the payee address",
     "tbjl":"Withdrawal record",
     "fzcg":"Copied successfully",
     "aqzx":"Security center",
     "yxrz":"Email authentication",
     "ybd":"Bound",
     "wbd":"Not bound",
     "yrz":"Verified",
     "wrz":"Not certified",
     "ts":"To protect your account, it is recommended to bind your email address",
     "qsryxdz":"Enter Email",
     "dlmm":"Login Password",
     "mbwtsz":"Security issue settings",
     "mbwt":"Security issue",
     "qtxda":"Please fill in the answer",
     "zyts":"Important: ",
     "zytsCont":"Please do not disclose the security answer and verification code, and remember the security question, which will help you recover your password.",
     "qsrxmm":"Enter a new password",
     "sydqmmcz":"Reset with current password",
     "zhmm":"Security issue to retrieve password",
     "ysz":"Has been set",
     "tg":"Ignore",
     "qsrdlmm":"Enter your password",
     "bzxz":"Select: ",
     "zwsj":"No data",
     "qd":"OK",
     "zsgd":"Show more",
     "zdss":"Minimum lot size",
     "mnjy":"Demo account",
     "sx":"screen",
   },
   "zb":{
     "tgdd":"AI managed orders",
     "tgz":"In custody",
     "ysh":"Redeemed",
     "shz":"Redemption",
     "zq":"Cycle: ",
     "tian":"Day",
     "syl2":"Rate of return: ",
     "rgjg":"Subscription price: ",
     "rgjg2":"Subscription price",
     "xdsj":"Order time: ",
     "yhl":"Profited: ",
     "syts":"The remaining number of days: ",
     "sh":"Redemption",
     "syl":"Rate of return",
     "bz":"Name",
     "dl":"Exchange rate",
     "tgts":"Hosting days: ",
     "tgsl":"Hosting quantity",
     "qsrtgsl":"Enter the hosting quantity",
     "dbxe":"Single transaction limit",
     "ljtg":"Host now",
     "zztg":"Funds in custody",
     "yjjrsy":"Estimated earnings today",
     "ljsy":"Cumulative income",
     "tgzdd":"Order in custody",
     "ljzc":"Transfer now",
     "gz":"Rule",
     "cpzq":"Product cycle",
     "gm":"Buy",
     "ts":"Important",
     "shts":"You are in the process of redemption operation, and you will lose 5% if you redeem before maturity. Are you sure to redeem?",
     "xgcs":"Number of purchase restrictions",
   },
   "dk":{
     "dk":"Loan",
     "dkzh":"Loan account",
     "yzsf":"Verify your identity and get more loan amounts!",
     "ksyz":"Start verification",
     "wxj":"I want to borrow...",
     "dkqx":"Loan term (days): ",
     "mrll":"Daily interest rate: ",
     "lxze":"Total interest: ",
     "dkts":"No interest is required on the loan for 3 days, and interest can be paid thereafter",
     "xzj":"Loan now",
     "wyydbzx":"Agree",
     "dkfwxy":"<Loan Service Agreement>",
     "dkfwxy2":"Loan Servicing Agreement",
     "dkysxy":"Loan Privacy Agreement",
     "dkjl":"Loan history",
     "hth":"No.",
     "yfk":"Disbursed",
     "lx":"Interest: ",
     "zhke":"Total repayment amount: ",
     "znj":"Late payment fee: ",
     "znjl":"Late payment fee rate: ",
     "yqts":"Days Overdue: ",
     "qhk":"To repay",
     "tpsc":"Credit loan (image upload)",
     "fwxx":"Housing information",
     "srzm":"Proof of income (employment relationship)",
     "yhmx":"Bank details",
     "zjz":"ID photo",
     "ljdk":"Loan now",
     "xm":"Name",
     "ndxm":"Your Name",
     "qsrndxm":"Enter your name",
     "gj":"Country",
     "ndgj":"Your country",
     "qsrndgj":"Enter your country",
     "dz":"Address",
     "nddz":"Your address",
     "qsrnddz":"Enter your address",
     "csrq":"Date of birth",
     "ndcsrq":"Your date of birth",
     "qsrndcsrq":"Enter your date of birth",
     "dhhm":"Phone number",
     "nddhhm":"Your phone number",
     "qsrnddhhm":"Enter your phone number",
     "zj":"Documents",
     "sfzm":"Positive identity",
     "qscsfzm":"Upload the positive side of your identity",
     "sffm":"Opposite of identity",
     "qscsffm":"Upload the reverse side of your identity",
     "ddqr":"Order Confirmation",
     "jk":"Loan: ",
     "dkqx2":"Loan term: ",
     "qrxd":"Confirm order",
     "yhkxq":"Details of repayment due",
     "hkqr":"Repayment confirmation",
     "yhk":"Repayment due: ",
     "jksj":"Borrowing time: ",
     "ljhk":"Pay off immediately",
   },
   "jy":{
     "rq":"date",
     "qqjy":"Option Records",
     "hyjy":"Contract",
     "qqhy":"Options",
     "dqwt":"Pending",
     'wtz':"In commission",
     "hyjl":"Contract record",
     "shou":"Lots",
     "dk":"O: ",
     "zhjg":"Latest: ",
     "jyfy":"Transaction fee: ",
     "kfsj":"Opening hours: ",
     "gg":"Lever: ",
     "pl":"Batch: ",
     "kpj":"Opening price: ",
     "yk":"Profit and loss: ",
     "cd":"Cancel order",
     "jsj":"Settlement Price: ",
     "fx":"Direction: ",
     "jgsj":"Delivery time: ",
     "gb":"Close",
     "jxxd":"Continue",
     "xj":"Limit: ",
     "gm":"Buy: ",
     "sl":"Quantity",
     "fy":"Cost: ",
     "tzbzj":"Adjust margin",
     "zyzs":"Take profit and stop loss",
     "pc":"Close position",
     "mr":"Buy",
     "zjbzj":"Increase margin",
     "jsbzj":"Reduce margin",
     "yxhy":"Contract Trading: ",
     "cc":"Position(s): ",
     "cc2":"Position",
     "cwbzk":"Position margin: ",
     "zdzjbzj":"Maximum increase in margin: ",
     "zjbzj2":"Increase margin: ",
     "qsrzbzj":"Please enter the deposit",
     "yxhy2":"Perpetual",
     "kp":"Can be flat",
     "zhang":"Open",
     "xj2":"Limit",
     "zy":"Take Profit",
     "zs":"Stop Loss",
     "ssjyzl":"Search transaction type",
     "ddb":"Order book",
     "di":"L: ",
     "gao":"H: ",
     "gb2":"C: ",
     "fz":"Minute",
     "mai":"Purchase: ",
     "zhang2":"Rise",
     "tie":"Fall",
     "sy":"Return",
     "kz":"Buy",
     "kt":"Sell",
     "bndy":"Cannot be lower than",
     "sxbzj":"Required security deposit: ",
     "ky":"Available: ",
     "sj":"Market",
     "mc":"Sell",
     "zxtzsl":"Minimum quantity",
     "min":"Minimum amount",
     "max":"Greatest amount",
     "yebz":"Insufficient balance",
     "ddz":"Waiting",
     "wtzl":"Amount of commissions: ",
     "wtjg":"Commission price: ",
     "ycd":"Canceled",
     "lswt":"Historical",
     "qsrzyjg":"Please enter the take profit price",
     "qsrzsjg":"Please enter stop loss price",
     "ccsl":"Number of positions: ",
     "ccjg":"Position price: ",
     "ggbs":"Leverage multiple: ",
     "zy2":"Take Profit: ",
     "zs2":"Stop Loss: ",
     "zje":"Lump sum: ",
     "ss":"Lots: ",
     "kcjg":"Opening price: ",
     "bzjl":"Margin rate: ",
     "lscc":"Historical",
     "gmj":"Purchase Price: ",
     "guadan":"Pending order",
     "dqjg":"Current price: ",
     "gdjg":"Pending order price: ",
     "pcjg":"Closing price: ",
     "ccsj":"Position holding time: ",
     "gdsj":"Order pending time: ",
     "pcsj":"Closing time: ",
     "fdjyk":"Floating net profit and loss",
     "pcsl":"Closing Quantity",
     "qrpc":"Confirm position closing",
     "ypc":"Position Closed",
     "ss2":"Lots",
     "qsrss":"Enter the lot size",
   },
   "gjrz":{
     "sfyz":"KYC Certification",
     "t1":"1. Supports JPG, JPEG or PNG format pictures smaller than 8M.",
     "t2":"2. The ID photo must be clear and no modification or blocking is allowed. The portrait, ID number and name must be clearly visible.",
     "t3":"3. The photo must be taken without a hat, and it is recommended not to wear makeup. The facial features of the person holding the document must be clearly visible, and the entire arm must be exposed.",
     "t4":"OK",
     "bh":"Reject",
     "shz":"Under review",
     "shtg":"Examination passed",
     "nyrzcg":"You have been authenticated successfully",
     "sczjz":"Upload ID photo",
     "sczjzmz":"Upload a front-facing photo of your ID",
     "sczjbmz":"Upload the photo of the back of your ID",
     "scgrqmz":"Upload a photo of your ID card in hand",
     "gjlb":"Country list",
     "qxzgjlb":"Select a country/region",
     "zsxm":"Actual name",
     "qsrzsxm":"Enter your real name",
     "zjlx":"Type of certificate: ",
     "zjhm":"ID number",
     "qsrzjhm":"Enter your ID number",
     "khh":"Account opening bank",
     "qsrkhh":"Enter the account opening bank",
     "yhkh":"Bank card number",
     "qsryhkh":"Enter bank card number",
   },
   "status":{
     "statusText":["Failed","Under review","Success"],
   },
   "download":{
     "t1":"Mobile trading, anytime, anywhere",
     "xz":"Download",
   },
   "langNew":{
     "cxsqsh": "Reapply",
     "jxtg": "Continue hosting",
     "szhb": "Crypto",
     "gjs": "Metal",
     "ny": "Energy",
     "yy": "Crude",
     "jy": "Trade",
     "jmhb": "Crypto",
     "yxhy": "Perpetual contract",
     "gdjy": "Pending order",
     "khh": "Account Opening",
     "qsrkhh": "Please enter your account bank",
     "yhkh": "Bank card number",
     "qsryhkh": "Please enter your bank card number",
     "mnzh":"Demo account",
     "zjjypt":"Best trading platform",
     "brjmzndxq":"This software meets all your needs with the best technical expertise",
     "jx":"Continue",
     "yssm":"Privacy statement",
     "fxqzc":"Anti-Money Laundering Policy",
     "jgxkz":"Regulatory license",
     "ckgd":"More",
     "gd":"More",
     "dd":"Order",
     "ckdd":"View orders",
     "yxdd":"Perpetual",
     "qqdd":"Options",
     "hand":"l lots= ",
     "lxwm":"Contact us",
     "tpfzl":"Place your image here, or",
     "liulang":"browse",
     "zctpgs":"Support: JPG, JPEG2000, PNG",
     "ysr":"Monthly income",
     "ndysr":"Your monthly income",
     "qsrndysr":"Enter your monthly income",
     "yqtzje":"Expected investment amount",
     "qsrtzje":"Enter the expected investment amount",
     "zszh":"Real account",
     "qdl":"Please login",
     "zx":"Favorites",
     "hkdz":"Repayment address",
     "dkje":"Loan amount: ",
     "zlx":"Total interest: ",
     "hkze":"Total repayment: ",
     "qcz":"Go to deposit",
     "yebz":"Your balance is insufficient, please recharge",
     "dhje":"Amount to be repaid：",
     "hkjl":"Repayment order：",
     "hkje":"Repayment amount：",
     "kyye":"Available balance：",
     "qb": 'All',
     "lmc": "Chain Name：",
     "search": "Search",
     "mrjg":"Price",
     "lxkf":"Contact",
     "wyj":"Liquidated Damages",
     "yxsj":"Running：",
     "jssj":"Finish：",
     "hksj":"Repayment：",
     "sysj":"Time left：",
     "jkqx":"Loan term：",
     "yq":"Overdue：",
     "qqss":"Your options trade oeder has expired Your loss is",
     "qqlr":"Your option trading order has expired and your profit is",
     "bz":"Currency",
     "dzje":"Receive funds",
     "lxyxzc":"Email support",

     "mnzh": "Demo Account",
         "zszh": "Real account",
         "qsrgjc": "Please enter keywords",
         "wh": "Forex",
         "szhb": "Digital Currency",
         "js": "Metal",
         "ny": "Energy",
         "sj": "market price",
         "gd": "Pending order",
         "mr": "Buy",
         "mc": "Sell",
         "ss": "Lot Size",
         "qsrss": "Please enter the lot size",
         "zy": "Take Profit",
         "zs": "Stop Loss",
         "qsrzyj": "Please enter the take profit price",
         "qsrzsj": "Please enter the stop loss price",
         "xfbzj": "Margin required:",
         "kyye": "Available Balance:",
         "cc": "Position",
         "ypc": "Closed Position",
         "name": "Name",
         "ddh": "Order Number",
         "mmfx": "Buy and sell direction",
         "gmfs": "Purchase Method",
         "xdj": "Order price",
         "sxf": "Service Fee",
         "sxf2": "Handling fee:",
         "cz": "Operation",
         "pc": "Close Position",
         "cx": "Undo",
         "pccg": "Closing successful",
         "dl": "Login",
         "yxhzhdl": "Account",
         "qsryxhzh": "Please enter your email address or account",
         "mm": "Password",
         "qsrmm": "Please enter a password",
         "cjxnzh": "Create a Demo Account",
         "wjmm": "Forgot password",
         "myzh": "No account?",
         "zc": "Registration",
         "wjmm2": "Forgot Password",
         "zh": "Account",
         "qsrzh": "Please enter account number",
         "yzm": "Verification Code",
         "qsryzm": "Please enter the verification code",
         "hqyzm": "Get Verification Code",
         "qrmm": "Confirm Password",
         "qzcsrmm": "Please enter the password again",
         "qd": "OK",
         "yxh": "Mailbox number",
         "qsryxh": "Please enter your mailbox number",
         "sjh": "Mobile phone number",
         "qsrsjh": "Please enter your phone number",
         "xm": "Name",
         "qsrxm": "Please enter your name",
         "gj": "Nationality",
         "qxzgj": "Please select a nationality",
         "zjlx": "Certificate Type",
         "qxzzjlx": "Please select a document type",
         "zjhm": "Document number",
         "qsrzjhm": "Please enter the ID number",
         "qpsbsczj": "Please take a photo and upload your ID",
         "pszm": "Shoot front",
         "psfm": "Shoot the reverse side",
         "qsczmz": "Please upload a frontal photo",
         "qscfmz": "Please upload a reverse photo",
         "scqmz": "Holding a signed photo",
         "qscqmz": "Please upload a signed photo",
         "wyyd": "I have read and understand",
         "yhxy": "User Agreement",
         "grzx": "Personal Center",
         "gnlb": "Function List",
         "smrz": "Real-name authentication",
         "rj": "Deposit",
         "cj": "Withdrawal",
         "zhjl": "Account Record",
         "xx": "Message",
         "wdyq": "My invitation",
         "zhaq": "Account Security",
         "sz": "Settings",
         "lmc": "Chain name",
         "bcewm": "Save QR code",
         "fzdz": "Copy address",
         "fzcg": "Copy successful",
         "rjsl": "Deposit Amount",
         "qsrsl": "Please enter the quantity",
         "zdsl": "Minimum Quantity",
         "pzms": "Hash value",
         "qsrpzms": "Please enter the hash value",
         "lkrj": "Deposit immediately",
         "cjdz": "Withdrawal Address",
         "qsrcjdz": "Please enter the withdrawal address",
         "cjsl": "Withdrawal Amount",
         "qsrcjsl": "Please enter the withdrawal amount",
         "lkcj": "Withdraw immediately",
         "ddh2": "Order number:",
         "time": "Time:",
         "je": "Amount:",
         "zt": "Status:",
         "bt": "Title:",
         "nr": "Content:",
         "sqz": "Applying",
         "yqhy": "Invite Friends",
         "yqhyyqzc": "Invite friends to register together",
         "wdyqm": "My invitation code",
         "wdyqlj": "My invitation link",
         "fz": "Copy",
         "xgdlmm": "Change login password",
         "szjymm": "Set transaction password",
         "xgmm": "Change Password",
         "tgyzmxgmm": "Change password through verification code",
         "jmm": "old password",
         "qsrjmm": "Please enter the old password",
         "dlmm": "Login Password",
         "qsrdlmm": "Please enter the login password",
         "jymm": "Transaction Password",
         "qsrjymm": "Please enter the transaction password",
         "mmcd": "Password length 6 digits",
         "tcdl": "Logout",
         "zxkf": "Online customer service",
         "bzzx": "Help Center",
         "ksrm": "Quick Start",
         "kcjg": "Open position price",
         "pcjg": "Close Price",
         "gdjg": "Pending order price",
         "pcfs": "Close Position",
         "hyl": "Contract Amount",
         "thbzj": "Refund Security Deposit",
         "gmsl": "Purchase Quantity",
         "sysl": "Remaining Quantity",
         "sccg": "Saved successfully",
         "qxdl": "Please log in first",
         "sy": "Profit",
         "tj": "Submit",
         "sfz": "ID card",
         "hz": "Passport",
         "jz": "Driver license",
         "qt": "Other",
         "qxzmnje": "Please select the simulated amount",
         "cjmnzhcg": "Create a demo account successfully!",
         "dlmmts": "Please enter the login password",
         "mmts": "Password length 6-24 digits",
         "jymmts": "Password length 6 digits",
         "shz": "Reviewing",
         "shtg": "Approved",
         "jj": "Reject",
         "xyb": "Next",
         "emailgsts": "The entered email address does not conform to the rules",
         "telgsts": "The format of the entered mobile phone number is incorrect",
         "lcmmbyz": "The two passwords entered are inconsistent",
         "gdj": "Pending order price",
         "lx": "Type",
         "qsrgdj": "Please enter the pending order price",
         "kccg": "Open position successfully!",
         "pcsl": "Closing Quantity",
         "mnts": "The virtual account has expired, please regenerate",
         "wtfa": "Delegation Scheme",
         "kcsj": "Open position time",
         "gbsj": "Close time",
         "gylx": "Swap",
         "hyjy": "Contract",
         "zwsj": "No data yet",
         "zwkf": "This recharge channel has not been opened yet",
   },
   "langNew9":{
   "dzje":"Market trends of trading products",
   "lxyxzc":"Start your digital trading journey",
   "text1":"Start by creating an account",
   "text2":"Invite friends to join MFTG to play together",
   "text3":"Recharge your account",
   "text4":"Support multiple currency recharges, allowing you to quickly start trading",
   "text5":"Start trading",
   "text6":"Provide a variety of high-quality trading pairs to choose from, and trade happily in MFTG",
    "text7":"Invite friends to earn USDT",
    "text8":"Invite friends to easily earn USDT",
    "text9":"Loan function is online",
    "text10":"When you have no money, you can apply for a loan, which will be issued on the same day at the earliest",
   "text11":"Trade all assets",
   "text12":"Forex, cryptocurrencies, futures, ETFs, etc",
   },
   "bank":{
     "text1":"Your most trusted financial platform",
     "text2":"Real-time news updates",
     "text3":"Understand real-time information of the financial industry",
     "text4":"Get started",
     "text5":"News Flash",
     "text6":"Select Bank",
     "text7":"bank card",
     "text8":"Amount...",
     "text9":"Add bank card",
     "text10":"Bank Account",
     "text11":"Please enter your bank account",
     "text12":"Card ID",
     "text13":"Please enter your card ID",
     "text14":"Bank International Code",
     "text15":"Bank International Code",
     "text16":"Please enter your phone number",
     "text17":"Add to",
     "text18":"Delete bank card",
     "text19":"Actual arrival",
     "text20":"Withdrawal information",
     "text21":"Select bank card",
     "text22":"Notes",
     "text23":"Minimum withdrawal amount:",
     "text24":"Withdrawal is not allowed if the amount is less than the minimum withdrawal amount",
     "text25":"• To ensure the safety of funds, when your account security policy changes or password changes, we will manually review the withdrawal. Please wait patiently for the staff to contact you by phone or email.",
     "text26":"• Please make sure that your computer and browser are safe to prevent information from being tampered with or leaked.",
     "text27":"• For the USD you withdraw, each operation means that the total amount of assets displayed on the withdrawal page you own will be reduced by the corresponding withdrawal amount.",
     "text28":"Withdrawal record",
     "text29":"Fiat currency type",
   },
   "kxt": {
       "fs": "time",
       "fz":"min",
       "xs":"hour",
       "tian":"day",
       "zhou":"week",
     },
     "xbsg":{
       "title": "Startup",
       "wdsg": "Details",
       "scts": "Locking days:",
       "sy": "Remaining",
       "ljsg": "Subscribe Now",
       "ysk": "Sold Out",
       "xzjdy": "Subscribe now",
       "dy": "Subscription",
       "fxjg": "Issuance Price",
       "fxl": "Circulation",
       "ssrq": "Listing Date",
       "yxqx": "Expiry Date",
       "qsrsl": "Please enter the quantity",
       "syl": "Remaining amount",
       "sgrq": "Purchase Date",
       "sgsl": "Purchase Quantity",
       "bz": "Currency",
       "yebz": "USDT balance insufficient",
       "tgsl": "pass quantity",
       "shz": "Reviewing",
       "wtg": "Failed",
       "ytg": "Passed",
       "ffsb": "Issuance failed",
       "yth": "Refunded",
       "sbly": "Failure Reason",
       "jjly": "Reason for rejection",
       "bz2": "Currency:",
       "fxjg2": "Issue price:",
       "sgsl2": "Purchase Quantity:",
       "tgsl2": "Pass quantity:",
       "sssj": "Time to market",
       "sssj2": "Time to market:",
       "sgj": "Subscription price",
       "sgj2": "Purchase Price:",
       "sgsj": "Purchase time",
       "sgsj2": "Purchase time:",
       "sbly2": "Failure reason:",
       "jjly2": "Reason for rejection:",
       "bzj": "Margin:",
       "zsxf": "Total transaction fee:",
       "djze": "Total amount frozen:",
       "djje": "Freeze Amount"
       },
       "bzhl":{
         "title":"Dividend",
         "gz":"Rules",
         "tgdd":"Escrow order",
         "zztgdzj":"Funds in custody",
         "yjjrsy":"Estimated daily",
         "ljsy":"Total revenue",
         "tgzdd":"Order in custody",
         "cljxcp":"Strategic campaign products",
         "dbxe":"Single limit",
         "rsyl":"Daily rate of return",
         "zq":"Cycle",
         "qmr":"Go and buy",
         "bbzhzc": "Account assets",
         "zcc": "总资产(USDT)",
         "dd":"Orders",
         "buy":"Buy in",
         "jxcp":"Featured Products",
         "ckdd":"Check order",
         "gd":"more",
         "xzbzts": "Simple and safe. Dividends can be selected in multiple currencies",
         "qtbz": "Other coins",
         "zrsy": "Yesterday's earnings",
         "zdisyl": "Minimum Yield",
         "zdasyl": "Maximum Yield",
         "day": "day",

         title1: 'AI Quantification',
         ttzbt: 'Keep making money every day',
         wdtg: 'Escrow order',
         zztgdzj: 'Funds in custody',
         yjjrsy: 'Estimated daily',
         ljsy: 'Cumulative income',
         tgzdd: 'Order in custody',
         tgdd: 'Escrow order',
         t1: 'Low-risk and stable financial management, redeemable at any time if necessary',
         t2: 'Your free money management assistant',
         cljxcp: 'Product cycle',
         dbxe: 'Single limit',
         rsyl: 'Daily return rate(%)',
         rsyl2: 'Daily return rate:',
         zq: 'Cycle',
         qmr: 'Go buy',
         ckgd: 'More',
         cpgk: 'Product Overview',
         pxsj: 'Dividend payout time',
         tgzj: 'Custody capital',
         tqsh: 'Early redemption',
         cpld: 'Product highlights',
         cpgz: 'Event Rules',
         cont: 'USDT earning are managed by the platforms professional team by hosting USDT on the platform. Participants can obtain the platforms revenue share during the fund hosting period, which can be accessed at any time, which is safe and convenient.',
         zj: '100% funding',
         aqbz: 'Security',
         jjrsy: 'Holiday income',
         bjd: 'Uninterrupted',
         cgcrh: 'After successful deposit',
         dtqx: 'Calculate interest on the day',
         ljzr: 'Transfer now',
         xqglgj: 'Free money management tools',
         ddh: 'Order number',
         tgje: 'Custody amount',
         tgsj: 'Cycle days',
         yhl: 'Profited/Days remaining',
         xdsj: 'Ordering time',
         zt: 'Status',
         fh: 'Back',
         qrnhsy: '7day annualized income',
         ygy: '1 month',
         bn: 'Half a year',
         yn: '1 year',
         yuan: '$',
         tzfx: 'investment risk',
         shsc: 'Redemption time',
         di: 'Low',
         yggzr: '1 working day',
         msgsxf: 'Free subscription fee',
         mr: 'Daily',
         dqfh: 'Return when due',
         ljgm: 'Buy now',
         tgz: 'Order in custody',
         sh: 'Early redemption',
         ywc: 'Completed',
         ysh: 'Redeemed',
         all: 'All',
         "xzbzts": "Simple and safe. Dividends can be selected in multiple currencies",
         "qtbz": "Other coins"
       },
       "bzhlgm":{
         "title":"Profits from brick removal",
         "bzhld":"Profits from brick removal USDT",
         "qtzq":"USDT 7-day cycle",
         "rsyl":"Daily return rat",
         "lczq":"Financial cycle",
         "dbxe":"Single remittance quota (USDT)",
         "pxsj":"Dividend payout time",
         "mr":"Daily",
         "dqfh":"Return when due",
         "tgzj":"Custody capital",
         "tqsh":"Early redemption",
         "yjsy":"Anticipated income (USDT)",
         "kyzc":"Available assets (USDT)",
         "cpjs":"About Our Products",
         "tgje":"Custody amount",
         "qsrtgje":"Please enter the custody amount",
         "qb":"All",
         "rm":"Buy now",
         "cpzq":"Product cycle",
         "jxr": "interest calculation day",
         "jiexr": "interest settlement date",
         "yjdzr": "Estimated arrival date",
         "gz":"Know the rules and interests",
         "ktgje": "Escrowable Amount: ",
       },
       "bzhlwdtg":{
         "title":"Order status",
         "tgz":"In custody",
         "ywc":"Completed",
         "ysh":"Redeemed",
         "tgje":"Custody amount/Custody time",
         "rsyl":"Daily return rat",
         "yhl":"Profited",
         "xdsj":"Ordering time",
         "sh":"Redemption",
         "ddxq":"Order details",
         "ddh":"Order No. "
       },
       "bzjj":{
         "t1": "Earn every day",
         "t2": "Brick removal is a process which transfers USDT to the platform, and professional platform teams have the authority to move bricks. Participants can share part of the platform's brick removal income during the capital custody period.",
         "cpld": "Product highlights",
         "scsq": "Deposit&take anytime",
         "pxzq": "Dividend cycle",
         "mtxf": "Distribute daily",
         "hqlx": "Current interest",
         "zj": "100% fund",
         "aqbz" :"Security",
         "jjrsy": "Holiday earnings",
         "sybjd": "Continuous profit",
         "bjd": "uninterrupted",
         "cgcrh": "After successful deposit",
         "dtqx": "interest value on the day",
         "jglz": "For example",
         "syjs": "Calculation of revenue",
         "cont1": "If a members has deposited 10,000 U on the platform and selected financial products with a maturation cycle of seven days and a daily return rate of 0.3-0.5%, then the daily return is as follows: ",
         "cont2": "Minimum: 10,000 U*0.3%=30U",
         "cont3": "Maximum: 10,000 U*0.5%=50U",
         "cont4": "namely, After 7 days, you can receive 210-350 U of income. This income will be distributed daily, and distributed income can be accessed at any time. The principal will automatically return to your wallet account after the expiration of the period.",
         "gywyj": "About liquidated damages",
         "cont5": "If you want to transfer out the undue principal, you will be subject to liquidated damages, which equals to default settlement ratio, multiplied by the remaining days, multiplied by the investment quantity",
         "cont6": "For example: If the default settlement ratio of the product is 0.4%, and is due to mature in 3 days, with an investment quantity of 1000, then the liquidated damages= 0.4%*3*1000=12 U, and the actual returned principal will be 1000 U-12 U=988 U",
         "wycy": "I want to join"
       },
       "wydb":{
         "title": "I want a loan",
         "db": "Currency",
         "dbz": "In currency",
         "jl": "Record",
         "jdzq": "Loan period (days)",
         "qhk": "Go to repay",
         "ljdb": "Accumulated loan currency (usdt)",
         "dhkbs" : "Number of pending repayments",
         "jkje": "Loan amount (usdt)",
         "qsrje": "Please enter the amount",
         "rll": "Daily Rate",
         "hkfs": "Repayment method",
         "dqych": "Repay principal and interest once due",
         "lx": "Interest",
         "fkjg": "Lending institution",
         "tpsc": "Credit loan (picture upload)",
         "fwxx": "House Information",
         "srzm": "Proof of Income",
         "yhmx": "Bank Details",
         "qscfwxx": "Please upload housing information",
         "qscsrzm": "Please upload proof of income",
         "qscyhmx": "Please upload bank details",
         "qsczjz": "Please upload ID photo",
         "zjz": "ID Photo",
         "yd": "I have read and agree",
         "xy": "Application Loan Agreement",
         "sqdb": "Click to apply for a loan",
         "gb": "close",
         "qd": "OK",
         "ts": "Please check the application loan agreement",
         "dbjl": "Loan Record",
         "hkhth": "Loan contract number",
         "wsh": "unreviewed",
         "yfk": "Disbursed",
         "sqrq": "Application Date",
         "zq": "period",
         "dbsl": "Amount of Loans",
         "zhke": "Total repayment amount",
         "yhkxq": "Repayment Details",
         "bqyhk": "Repayment due in this period (USDT)",
         "hktips": "Please ensure that the balance is sufficient, if the balance is insufficient, please recharge before repaying",
         "bj": "Principal",
         "jie": "borrow",
         "ljhk": "Repay immediately",
         "qcz": "Go to recharge",
         "yebzqxcz": "Insufficient balance, please recharge before repaying",
         "znj": "Late payment fee",
         "yqts": "Number of days past due",
         "kjdje": "Borrowable Amount",
         "rlxl": "Daily interest rate",
         "rlxl2": "Daily interest rate:",
         "yqll": "Deferred Interest Rate",
         "yqll2": "Deferred interest rate:",
         "ljlx": "Accumulated Interest",
         "zrlx": "Yesterday's Interest",
         "jddd": "Loan order",
         "zxje": "Minimum amount:",
         "jexz": "Amount limit:",
         "xypztp": "Credential image:",
         "hkpztp": "Repayment voucher picture:",
         "ysxsl": "Amount of Interest Earned:",
         "ysxts": "Number of days that have accrued interest:",
         "jdsl": "Loan amount:",
         "fkjg2": "Lending institution:",
         "zq2": "Period:",
         "sqrq2": "Application date:",
         "zhke2": "Total repayment amount:",
         "yff": "Issued",
         "hkz": "Repayment",
         "yjq": "Cleared",
         "jjdk": "Reject loan",
         "ch": "Withdraw",
         "cxsq": "Reapply",
         "cgkdkxz": "Exceeded loan limit",
         "hdgz": "Event Rules"
       },
       "xyf":{
         "title": "Credit Score",
         "dqxyf": "Current credit score",
         "hwqxyf": "You have not obtained credit points",
         "zwxyf": "No credit score yet",
         "pgsj": "Evaluation Time",
         "xypz": "Credentials (image upload)",
         "cxtjsh": "Resubmit for review",
         "tjsh": "Submit for review",
         "yjj": "Rejected",
         "hq": "Get",
         "qx": "Cancel",
         "qxwcsmrz": "Complete real-name authentication first"
       },
       "hkxq":{
         "dd": "Order",
         "fzhkdz": "Copy repayment address",
         "hkxq": "Repayment details",
         "zlx": "Total Interest",
         "zhk": "Total Repayment",
         "hkjg": "Repayment Agency",
         "qschkpz": "Please upload the repayment voucher",
         "hkpz": "Repayment Voucher",
         "lxkfhk": "Contact customer service for repayment"
       },
       "tipsNew":{
         "wjmmts": "Recover password by verification code",
         "qscpztp": "Please upload the voucher image",
         "emailgsts": "Input mailboxes do not conform to the rules",
         "telgsts": "The mobile phone number is incorrect",
         "lcmmbyz": "Please confirm your password",
         "zdsl": "Minimum Qty ",
         "sldydy": "Quantity greater than or equal to",
         "zxtzsl": "Minimum investment amount ",
         "ddz": "waiting",
         "xs": "hour",
         "min": "Minimum amount ",
         "max": "Maximum amount ",
         "yebz": "Insufficient balance",
         "qsrss": "Please input lots",
         "zdss": "Minimum lots",
         "yjj": "Rrejected",
         "shz": "Redemption"
       },
       "status":{
         "statusText": ['failure','under review','success'],
       },
       "jghy":{
         "jghy": "Swap",
         "yxhy": "Futures",
         "mz": "Buy",
         "md": "Sell",
         "gmj": "Purchase Price",
         "jsj": "Settlement pric",
         "xj": "Current price",
         "fx": "Direction",
         "sl": "Volume",
         "jgsj": "Delivery time",
         "gb": "Close",
         "jxxd": "Continue to place an order",
         "cclb": "Order list",
         "zc": "Current",
         "lscc": "History",
         "qblx": "All",
         "yk": "Profit",
         "ddqr": "Order Confirmation",
         "dqsj": "Expire time",
         "jssj": "Delivery time",
         "sy": "Profit",
         "tzje": "Investment amount",
         "zdje": "Lowest price 0",
         "kyye": "Available",
         "sxf": "Handling fee",
         "sxfl": "Fee rate",
         "jypz": "Pair",
         "jyfx": "Direction",
         "qrxd": "Confirm",
         "fs": "Line",
         "dqye": "Current balance",
         "zt": "Status"
       },
       "bbjy":{
        "cjsj":"Transaction time",
        "wtjg":"Commission Price",
        "cjjg":"Transaction price",
        "wcj":"Unsold",
        "ycj":"Transaction completed",
        "yqx":"Canceled",
        "qxwt":"Cancel the order",
        "qsrxj": "Please enter the limit price"
      },
      "dcwj0":{
        "t1":"Purpose of account opening",
        "t2":"What do you plan to do with FXLY?",
        "arr":[
          {
            'id': 1,
            "title": "Buy and trade foreign exchange/energy/cryptocurrency"
          },
          {
            'id': 2,
            "title": "Long-term investment/spot trading"
          },
          {
            'id': 3,
            "title": "Short-term trading/secondary market"
          },
          {
            'id': 4,
            "title": "Financial management of mining pools"
          },
          {
            'id': 5,
            "title": "Private placement of currencies"
          },
          {
            'id': 6,
            "title": "All of the above"
          },
        ]
      },
      "dcwj1":{
        "t1":"Purpose of investment",
        "t2":"What do you plan to do with your funds?",
        "arr":[
          {
            'id': 1,
            "title": "Personal investment"
          },
          {
            'id': 2,
            "title": "Investment in family"
          },
          {
            'id': 3,
            "title": "Company investment"
          },
          {
            'id': 4,
            "title": "Other"
          },
        ]
      },
      "dcwj2":{
        "t1":"Investment amount",
        "t2":"What is your expected investment?",
        "arr":[
          {
            'id': 1,
            "title": "$100—$1000"
          },
          {
            'id': 2,
            "title": "$1000—$10,000"
          },
          {
            'id': 3,
            "title": "$10,000—$100,000"
          },
          {
            'id': 4,
            "title": "$100,000—$500,000"
          },
          {
            'id': 5,
            "title": "$500,000—$1,000,000"
          },
          {
            'id': 6,
            "title": "Over $1,000,000"
          },
        ]
      },
      "dcwj3":{
        "t1":"Expected transactions",
        "t2":"How many transactions do you plan to make in a month?",
        "arr":[
          {
            'id': 1,
            "title": "5-100"
          },
          {
            'id': 2,
            "title": "100-300"
          },
          {
            'id': 3,
            "title": "300-1000"
          },
          {
            'id': 4,
            "title": "Over 1000"
          },
        ]
      },
      "dcwj4":{
        "t1":"Type of work",
        "t2":"What is your occupation?",
        "arr":[
          {
            'id': 1,
            "title": "Semiconductor"
          },
          {
            'id': 2,
            "title": "Worker"
          },
          {
            'id': 3,
            "title": "Technology"
          },
          {
            'id': 4,
            "title": "Farmer"
          },
          {
            'id': 5,
            "title": "Sales"
          },
          {
            'id': 6,
            "title": "Service industry"
          },
          {
            'id': 7,
            "title": "Finance"
          },
          {
            'id': 8,
            "title": "Medical"
          },
          {
            'id': 9,
            "title": "Internet"
          },
          {
            'id': 10,
            "title": "Physical investor"
          },
          {
            'id': 11,
            "title": "Catering"
          },
          {
            'id': 12,
            "title": "Other"
          },
        ]
      },
   // "langNew2":{
   //   "sy":"Home",
   //   "sc":"Market",
   //   "sclb":"Market List",
   //   "jy":"Trade",
   //   "zh":"Account",
   //   "db":"Loans",
   //   "zchm":"Registration Number",
   //   "cp":"Product",
   //   "tzjd":"Investment loans",
   //   "zxzc":"Online Support",
   //   "xd":"Order",
   //   "zzjptgmnr":"Invest in your future.Grow your portfolio in a fair and open financial system.",
   //   "yy":"App",
   //   "pqnr":"Mobile banking that breaks away from traditional rules and provides you with precise financial management tools.",
   //   "jiami":"Crypto",
   //   "tgnr":"By making deposits using crypto, you gain an extra layer of security and ensure fast transaction processing.",
   //   "jyl":"24h Trading Volume",
   //   "ssjmhb":"Crypto listing",
   //   "zchy":"Registered Users",
   //   "djxz":"Click to Download",
   //   "azsc":"Android Market",
   //   "pgsd":"Apple Store",
   //   "bqxx":'©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
   // }
}



// WEBPACK FOOTER //
// ./src/lang/en.js